const fr = {
  // Common words and phrases
  common: {
    back: "Retour",
    search: "Rechercher",
    filter: "Filtrer",
    clear: "Effacer",
    export: "Exporter",
    download: "Télécharger",
    loading: "Chargement...",
    save: "Enregistrer",
    save_changes: "Enregistrer les modifications",
    apply: "Appliquer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    view: "Voir",
    add: "Ajouter",
    name: "Nom",
    email: "Email",
    password: "Mot de passe",
    confirm: "Confirmer",
    submit: "Soumettre",
    error: "Erreur",
    success: "Succès",
    warning: "Avertissement",
    info: "Information",
    merchant: "Commerçant",
    description: "Description",
    account: "Compte",
    type: "Type",
    actions: "Actions",
    yes: "Oui",
    no: "Non",
    all: "Tous",
    none: "Aucun",
    select: "Sélectionner",
    for: "pour",
    in: "dans",
    showMore: "Afficher plus",
    showLess: "Afficher moins",
    clearFilter: "Effacer le filtre",
    page: "Page",
    institution: "Institution",
    status: "Statut",
    action: "Action",
    reference: "Référence",
    balance: "Solde",
    increase: "Augmentation",
    decrease: "Diminution",
    language: "Langue",
    amount: "Montant",
    date: "Date",
    group: "Groupe",
    category: "Catégorie",
    transactions: "Transactions",
    total: "Total",
    viewReport: "Voir le rapport",
    other: "Autre",
    selectCountries: "Sélectionner les pays",
    noCountryFound: "Aucun pays trouvé.",
    currency: "Devise",
    country: "Pays",
    continue: "Continuer",
    or: "ou",
  },

  // Time related
  time: {
    today: "Aujourd'hui",
    yesterday: "Hier",
    thisWeek: "Cette semaine",
    lastWeek: "Semaine dernière",
    thisMonth: "Ce mois",
    lastMonth: "Mois dernier",
    thisYear: "Cette année",
    lastYear: "Année dernière",
    custom: "Personnalisé",
    from: "De",
    to: "À",
    now: "Maintenant",
    quarter: "Trimestre",
    year: "Année",
    month: "Mois",
    period: "Période",
    startMonth: "Mois de début",
    endMonth: "Mois de fin",
    startQuarter: "Trimestre de début",
    endQuarter: "Trimestre de fin",
    lastQuarter: "Derniers 90 jours",
    allTime: "Tout le temps",
  },

  // Navigation and menus
  nav: {
    passiveIncome: "Revenus passifs",
    dashboard: "Tableau de bord",
    transactions: "Transactions",
    accounts: "Comptes",
    categories: "Catégories",
    reports: "Rapports",
    settings: "Paramètres",
    users: "Utilisateurs",
    logout: "Déconnexion",
    login: "Connexion",
    register: "S'inscrire",
    profile: "Profil",
    preferences: "Préférences",
    help: "Aide",
    support: "Support",
    about: "À propos",
    currencyRates: "Taux de change",
    financialSummary: "Résumé Financier",
    portfolioHoldings: "Portefeuille",
    tagAnalytics: "Analyse par tags",
    equityAnalysis: "Analyse des actions",
    expenses: "Dépenses",
    agents: "Agents Bliss",
    importAgent: "Agent d'importation",
    insightAgent: "Insights IA",
    travelAgent: "Agent de voyage",
    manageAssets: "Gérer les actifs",
    assetsLiabilities: "Actifs et passifs",
    transactionReview: "Révision des transactions",
    subscriptions: "Abonnements",
  },

  // Page titles and descriptions
  pages: {
    oauth: {
      consent: {
        title: "Connecter {{client}} à Bliss",
        subtitle: "Cette application souhaite utiliser vos données Bliss via le serveur MCP.",
        signed_in_as: "Connecté en tant que {{email}}",
        redirect_notice: "Après votre choix, vous serez renvoyé vers",
        access_label: "Accès",
        read_only_description: "Voir les transactions, le portefeuille, les analyses et les insights. Elle ne peut rien modifier.",
        read_write_description: "Aussi recatégoriser les transactions, traiter vos files de révision et modifier les données du portefeuille.",
        expiry_label: "La connexion expire après",
        no_expiry_warning: "Une connexion sans expiration fonctionne jusqu'à ce que vous la révoquiez.",
        footnote: "L'application voit vos données financières déchiffrées. Vous pouvez révoquer la connexion à tout moment dans Paramètres → Intégrations.",
        admin_required: "Seul un administrateur de l'espace peut connecter des applications. Demandez à un administrateur de la connecter.",
        allow: "Autoriser",
        deny: "Refuser",
        error_title: "Impossible de finaliser cette connexion",
        error_missing: "Ce lien est incomplet. Relancez la connexion depuis votre application.",
        error_generic: "Une erreur s'est produite. Relancez la connexion depuis votre application.",
      },
    },
    dashboard: {
      title: "Tableau de bord",
      subtitle: "Vue d'ensemble de votre situation financière",
      summary: "Résumé",
      recentTransactions: "Transactions récentes",
      quickActions: "Actions rapides",
      insights: "Analyses",
      totalNetWorth: "Valeur nette totale",
    },
    accounts: {
      title: "Comptes",
      subtitle: "Gérez vos comptes financiers",
      addAccount: "Ajouter un compte",
      editAccount: "Modifier le compte",
      deleteAccount: "Supprimer le compte",
      accountDetails: "Détails du compte",
      noAccounts: "Aucun compte trouvé",
      hasBeenRemoved: "a été supprimé",
    },
    transactions: {
      title: "Transactions",
      subtitle: "Voir et gérer vos transactions",
      addTransaction: "Ajouter une transaction",
      editTransaction: "Modifier la transaction",
      deleteTransaction: "Supprimer la transaction",
      transactionDetails: "Détails de la transaction",
      noTransactions: "Aucune transaction trouvée",
      filter: "Filtrer les transactions",
      import: "Importer des transactions",
      export: "Exporter des transactions",
      allAccounts: "Tous les comptes",
      allGroups: "Tous les groupes",
      allCategories: "Toutes les catégories",
      categoryGroup: "Groupe de catégorie",
      exportCsv: "Exporter CSV",
      importCsv: "Importer CSV",
      exportComplete: "Exportation terminée",
      csvDownloaded: "CSV téléchargé avec succès",
      exportFailed: "Échec de l'exportation",
      exporting: "Exportation en cours...",
      exportTransactions: "Exporter les transactions",
      exportDescription: "Choisissez les transactions à exporter",
      currentFilters: "{{count}} transactions correspondant aux filtres actuels",
      allTransactions: "Toutes les transactions",
      exportingTransactions: "Exportation de vos transactions...",
      exportingNote: "Cela peut prendre un moment. Veuillez ne pas fermer cette fenêtre.",
      noTransactionsFound: "Aucune transaction trouvée",
      tryDifferentFilters: "Essayez d'ajuster vos filtres pour trouver ce que vous cherchez.",
      startDate: "Date de début",
      endDate: "Date de fin",
      pickDate: "Choisir une date",
      editTransactionDescription: "Modifiez les détails de cette transaction.",
      addTransactionDescription: "Remplissez les détails pour ajouter une nouvelle transaction.",
    },
    categories: {
      title: "Catégories",
      subtitle: "Gérez les catégories de transactions",
      addCategory: "Ajouter une catégorie",
      editCategory: "Modifier la catégorie",
      deleteCategory: "Supprimer la catégorie",
      categoryDetails: "Détails de la catégorie",
      noCategories: "Aucune catégorie trouvée",
    },
    reports: {
      title: "Rapports",
      subtitle: "Sélectionnez un type de rapport pour obtenir des informations financières détaillées",
      financialSummary: {
        title: "Résumé Financier",
        description: "Voir les revenus et dépenses sur différentes périodes"
      },
      expenses: {
        title: "Suivi des dépenses",
        description: "Analyser les habitudes de dépenses par catégorie"
      },
      portfolio: {
        title: "Portefeuille",
        description: "Voir et analyser votre portefeuille d'investissements"
      },
      recentReports: {
        title: "Rapports récents",
        description: "Vos rapports générés récemment",
        empty: "Aucun rapport récent trouvé.",
        hint: "Les rapports que vous générez apparaîtront ici pour un accès rapide."
      }
    },
    currencyRates: {
      title: "Taux de change",
      subtitle: "Surveiller et gérer les taux de change",
      baseCurrency: "Devise de base",
      targetCurrency: "Devise cible",
      currentRate: "Taux actuel",
      historicalRates: "Taux historiques",
      updateRate: "Mettre à jour le taux",
    },
    financialSummary: {
      title: "Résumé Financier",
      subtitle: "Voir et analyser vos revenus et dépenses",
      statement: "État",
      trend: "Tendance mensuelle",
      breakdown: "Détail des revenus et dépenses",
      chartDescription: "Répartition mensuelle des revenus, dépenses et épargne",
      downloadStatement: "Télécharger l'état complet",
      netIncome: "Revenu net",
      netSavings: "Épargne Nette",
      totalRevenue: "Revenus totaux",
      totalExpenses: "Dépenses totales",
      savingsRate: "Taux d'Épargne",
      topExpense: "Principale dépense",
      discretionaryIncome: "Revenu Discrétionnaire",
      savingsCapacity: "Capacité d'Épargne",
      otherActivity: "Autre Activité",
    },
    portfolio: {
      title: "Portefeuille",
      description: "Suivez et analysez votre portefeuille d'investissements par type d'actif",
      subtitle: "Suivez et analysez votre portefeuille d'investissements par type d'actif",
      totalValue: "Valeur totale du portefeuille",
      totalHoldings: "Sur {{count}} positions",
      gainLoss: "Gain/Perte total",
      overallReturn: "{{value}}% de rendement total",
      assetBreakdown: "Répartition par classe d'actifs",
      holdings: "Liste des positions",
      allocation: "Allocation d'actifs",
      performance: "Performance",
      holdingsDescription: "Vos investissements groupés par type d'actif",
      allocationDescription: "Répartition de votre portefeuille par type d'actif",
      performanceDescription: "Comparaison des gains et pertes par type d'actif",
      search: "Rechercher des positions...",
      assetAndType: "Actif et type",
      symbolId: "Symbole/ID",
      qtyUnits: "Qté/Unités",
      currentPrice: "Prix actuel",
      marketValue: "Valeur de marché",
      gainLossValue: "Gain/Perte",
      percentReturn: "% Rendement"
    },
    expenses: {
      title: "Suivi des dépenses",
      description: "Analysez vos habitudes de dépenses par catégorie",
      selectCategoryType: "Sélectionner le type de catégorie",
      countriesSelected: "{{count}} pays sélectionnés",
      includeCredits: {
        label: "Inclure les crédits",
        tooltip: "Activé : les crédits dans les catégories de dépenses (remboursements, la part d'un colocataire, indemnités d'assurance) sont soustraits des débits. Désactivé : affiche uniquement les débits."
      },
      basis: {
        net: "débits − crédits",
        debitOnly: "débits uniquement"
      },
      timeFrame: {
        label: "Période",
        month: "Mois",
        quarter: "Trimestre",
        year: "Année"
      },
      export: "Exporter",
      metrics: {
        totalExpenses: "Dépenses totales",
        averageMonthly: "Moyenne mensuelle",
        highestCategory: "Catégorie la plus élevée",
        monthlyAverage: "Moyenne mensuelle"
      },
      breakdown: {
        title: "Répartition des dépenses",
        description: "Voir vos dépenses par catégorie",
        tabs: {
          byCategory: "Par catégorie",
          monthlyTrends: "Tendances mensuelles",
          detailedList: "Liste détaillée"
        },
        topCategories: "Principales catégories de dépenses",
        netCredits: "Crédits nets",
        netCreditsCaption: "Le total inclut {{amount}} de crédits nets",
        noNetSpend: "Aucune dépense nette sur cette période",
        trendChart: {
          movingAverageSuffix: " (moy. 6 mois)"
        },
        comingSoon: {
          trends: "La vue des tendances mensuelles sera bientôt disponible.",
          details: "La liste détaillée des dépenses sera bientôt disponible."
        },
        details: {
          emptyTitle: "Sélectionnez une catégorie",
          emptyDescription: "Cliquez sur une tranche du graphique ou sur une ligne de catégorie pour voir les transactions individuelles.",
          goToCategories: "Aller aux catégories",
          capNotice: "Affichage des 1 000 premières transactions ; les totaux peuvent être incomplets",
        }
      }
    },
    settings: {
      title: "Paramètres du compte",
      description: "Gérez vos préférences et paramètres de compte",
      language: "Langue",
      error_loading_reference_data: "Échec du chargement des données de référence. Veuillez actualiser la page.",
      error_saving_no_id: "Impossible de trouver votre ID utilisateur pour enregistrer les paramètres.",
      error_saving_generic: "Une erreur inconnue s'est produite lors de l'enregistrement.",
      success_saving: "Vos paramètres ont été enregistrés avec succès.",
      tabs: {
        general: "Général",
        countries_currencies: "Pays et devises",
        banks: "Banques",
        connections: "Connexions",
        integrations: "Intégrations",
        ai_classification: "Classification IA",
        maintenance: "Maintenance",
        admin_section: "Administration",
        processing: "Traitements",
        bank_sync: "Synchro bancaire",
      },
      general: {
        title: "Paramètres généraux",
        description: "Configurez les paramètres généraux de votre tenant",
        tenant_name_label: "Nom du tenant",
        tenant_name_description: "Il s'agit du nom de votre organisation ou de votre profil de finances personnelles.",
        user_management_label: "Gestion des utilisateurs",
        user_management_button: "Gérer les utilisateurs",
        user_management_description: "Gérez les utilisateurs ayant accès à votre compte tenant.",
        sign_out_others: {
          label: "Autres appareils",
          description: "Déconnectez-vous partout sauf sur cet appareil. Vos autres navigateurs et applications installées devront se reconnecter.",
          button: "Se déconnecter de tous les autres appareils",
          confirm_title: "Se déconnecter de tous les autres appareils ?",
          confirm_description: "Tous les autres navigateurs et applications installées connectés à votre compte seront déconnectés à leur prochaine requête. Cet appareil reste connecté.",
          confirm: "Déconnecter les autres",
          success: "Les autres appareils ont été déconnectés.",
          error: "Impossible de déconnecter les autres appareils. Veuillez réessayer.",
        },
      },
      countries: {
        title: "Pays",
        description: "Pays où vous avez des activités financières",
        selected_label: "Pays sélectionnés",
        available_label: "Pays disponibles",
        none_selected: "Aucun pays sélectionné"
      },
      currencies: {
        title: "Devises",
        description: "Devises que vous utilisez dans vos transactions",
        selected_label: "Devises sélectionnées",
        available_label: "Devises disponibles",
        none_selected: "Aucune devise sélectionnée"
      },
      banks: {
        title: "Paramètres des banques",
        description: "Gérez les banques que vous utilisez dans vos activités financières",
        selected_label: "Vos banques",
        available_label: "Banques disponibles",
        none_selected: "Aucune banque sélectionnée"
      },
      connections: {
        title: "Connexions Plaid",
        description: "Gérez vos connexions bancaires liées et leur état de synchronisation",
        no_connections: "Aucune connexion bancaire. Utilisez 'Connecter une banque' pour lier votre premier compte.",
        status_active: "Actif",
        status_login_required: "Connexion requise",
        status_error: "Erreur",
        status_revoked: "Révoqué",
        status_pending: "En attente",
        last_sync: "Dernière synchronisation",
        never_synced: "Jamais synchronisé",
        error_code: "Erreur",
        reconnect: "Reconnecter",
        reconnect_description: "Ré-authentifiez votre connexion bancaire pour reprendre la synchronisation.",
        connection_warning: "Une ou plusieurs connexions bancaires nécessitent votre attention.",
        accounts_linked: "comptes liés",
      },
      integrations: {
        title: "Intégrations et jetons API",
        description: "Permettez à des agents IA, des scripts et d'autres systèmes d'utiliser l'API Bliss. Chaque intégration dispose de ses propres jetons, révocables à tout moment.",
        create: "Nouvelle intégration",
        create_title: "Nouvelle intégration",
        add_key_title: "Ajouter une clé",
        rename_title: "Renommer l'intégration",
        empty: "Aucune intégration pour le moment. Créez-en une pour connecter un agent IA ou un autre système.",
        loading_error: "Impossible de charger les intégrations.",
        acting_note: "Les requêtes avec un jeton agissent en votre nom, dans la limite du niveau d'accès choisi. Si votre utilisateur est supprimé, vos intégrations sont révoquées.",
        security_note: "Quiconque détient un jeton peut voir vos données financières déchiffrées. Traitez-le comme le mot de passe de votre banque.",
        access_read_only: "Lecture seule",
        access_read_write: "Lecture et écriture",
        access_read_only_description: "Peut lire les transactions, le portefeuille, les analyses et les insights. Ne peut rien modifier.",
        access_read_write_description: "Peut aussi créer et modifier des transactions, des étiquettes et des imports, et traiter la file de revue Plaid. Ne peut pas gérer les comptes, catégories, utilisateurs, connexions bancaires ni les paramètres.",
        status_active: "Active",
        status_revoked: "Révoquée",
        status_expired: "Expirée",
        keys_count: "{{count}} clé(s) active(s) sur {{total}}",
        last_used: "Dernière utilisation",
        never_used: "Jamais",
        expires: "Expire",
        no_expiry: "Pas d'expiration",
        add_key: "Ajouter une clé",
        revoke_key: "Révoquer",
        revoke_integration: "Révoquer l'intégration",
        rename: "Renommer",
        show_keys: "Clés",
        hide_keys: "Masquer les clés",
        form: {
          name_label: "Nom",
          name_placeholder: "ex. Agent Claude",
          name_required: "Saisissez un nom.",
          description_label: "Description (facultative)",
          access_label: "Niveau d'accès",
          access_fixed: "Le niveau d'accès ne peut pas être modifié ensuite. Pour le changer, créez une nouvelle intégration.",
          key_name_label: "Nom de la clé (facultatif)",
          key_name_placeholder: "ex. Ordinateur portable",
          expiry_label: "La clé expire après",
          expiry_30: "30 jours",
          expiry_90: "90 jours",
          expiry_365: "1 an",
          expiry_never: "Jamais",
          no_expiry_warning: "Une clé sans expiration reste valide jusqu'à ce que vous la révoquiez.",
          create_submit: "Créer l'intégration",
          add_key_submit: "Créer la clé",
          save: "Enregistrer",
          cancel: "Annuler",
        },
        reveal: {
          title: "Copiez votre jeton",
          subtitle: "Utilisez-le comme jeton Bearer dans l'en-tête Authorization.",
          warning: "Ce jeton ne sera plus affiché. Conservez-le en lieu sûr, par exemple dans un gestionnaire de mots de passe.",
          copy: "Copier",
          copied: "Copié",
          example: "Exemple de requête",
          done: "Terminé",
        },
        mcp: {
          title: "Utiliser avec Claude (MCP)",
          description: "Connectez Claude Code ou un autre client MCP avec cette clé. Il voit les mêmes données que la clé autorise : une clé en lecture seule ne peut que lire.",
          url_label: "URL du serveur MCP :",
          copy_command: "Copier la commande",
        },
        oauth: {
          badge: "Connectée via OAuth · {{client}}",
          expires: "La connexion expire le {{date}}",
          no_expiry: "La connexion n'expire jamais",
        },
        confirm: {
          revoke_key_title: "Révoquer cette clé ?",
          revoke_key_description: "Tout ce qui utilise cette clé cessera de fonctionner à la prochaine requête. Les autres clés de l'intégration restent valides.",
          revoke_integration_title: "Révoquer cette intégration ?",
          revoke_integration_description: "Toutes ses clés cessent de fonctionner immédiatement. Cette action est irréversible.",
          confirm_revoke: "Révoquer",
        },
        toast: {
          created: "Intégration créée",
          key_created: "Clé créée",
          key_revoked: "Clé révoquée",
          revoked: "Intégration révoquée",
          renamed: "Intégration mise à jour",
          error: "Une erreur s'est produite. Veuillez réessayer.",
        },
      },
    },
    users: {
      title: "Utilisateurs",
      subtitle: "Gérer les comptes utilisateurs et les permissions",
      addUser: "Ajouter un utilisateur",
      editUser: "Modifier l'utilisateur",
      deleteUser: "Supprimer l'utilisateur",
      userDetails: "Détails de l'utilisateur",
      noUsers: "Aucun utilisateur trouvé",
      roles: "Rôles et permissions",
    },
    notFound: {
      title: "Page introuvable",
      subtitle: "La page que vous recherchez n'existe pas",
      goBack: "Retour à la page d'accueil",
    },
    login: {
      confirm_identity: {
        title: "Confirmez votre identité",
        description: "Pour votre sécurité, confirmez votre identité pour continuer. C'est nécessaire lorsque votre dernière connexion date de plus de 15 minutes.",
        password_label: "Mot de passe",
        confirm: "Confirmer",
        google: "Continuer avec Google",
        divider: "ou",
        wrong_password: "Mot de passe incorrect. Veuillez réessayer.",
        error: "Impossible de confirmer votre identité. Veuillez réessayer.",
        no_method: "Ce compte ne peut pas confirmer son identité ici. Déconnectez-vous, reconnectez-vous, puis réessayez.",
      },
      title: "Connexion",
      subtitle: "Connectez-vous à votre compte",
      noAccount: "Vous n'avez pas de compte ?",
      signUp: "S'inscrire",
      rememberMe: "Se souvenir de moi",
    },
    agents: {
      title: "Agents Bliss",
      subtitle: "Assistants financiers alimentés par l'IA",
    },
    importAgent: {
      title: "Agent d'importation",
      subtitle: "Importez et traitez des données financières de diverses sources",
      description: "Téléchargez et catégorisez automatiquement les transactions depuis des fichiers CSV/PDF",
      dropzone: "Déposez des fichiers ici ou cliquez pour parcourir",
      processing: "Traitement de vos documents",
      success: "Importé avec succès",
      failed: "Échec de l'importation",
      supportedFormats: "Formats pris en charge : CSV, PDF, Excel",
      parseOptions: "Options d'analyse",
      mapColumns: "Mapper les colonnes",
      preview: "Aperçu des données",
      import: "Importer les données",
    },
    insightAgent: {
      title: "Agent d'analyse",
      subtitle: "Obtenez des analyses et recommandations financières personnalisées",
      description: "Analysez vos habitudes de dépenses et recevez des conseils financiers adaptés",
      generating: "Génération des analyses",
      noData: "Plus de données de transactions nécessaires pour générer des analyses",
      categories: "Analyses par catégorie",
      trends: "Tendances de dépenses",
      recommendations: "Recommandations",
      savingOpportunities: "Opportunités d'épargne",
      budgetSuggestions: "Suggestions de budget",
    },
    travelAgent: {
      title: "Agent de voyage",
      subtitle: "Gérez vos dépenses et budgets de voyage",
      description: "Planifiez des voyages, suivez les dépenses et optimisez les dépenses de voyage",
      upcoming: "Prochains voyages",
      past: "Voyages passés",
      expenses: "Dépenses de voyage",
      currency: "Conversion de devises",
      planning: "Planification de voyage",
      budgeting: "Budget de voyage",
      addTrip: "Ajouter un voyage",
      editTrip: "Modifier le voyage",
    },
    comingSoon: {
      title: "Bientôt disponible",
      subtitle: "Cette fonctionnalité est en cours de développement",
      description: "Nous travaillons dur pour vous apporter cette fonctionnalité. Revenez bientôt !",
      backToHome: "Retour au tableau de bord",
    },
    manualUpdates: {
      title: "Actifs et passifs",
      subtitle: "Gérez les prix de vos actifs et les conditions de dette",
      assetsNeedingUpdate: "Actifs nécessitant une mise à jour de prix",
      liabilities: "Passifs",
      noAssetsNeedUpdate: "Tous les actifs sont à jour.",
      noLiabilities: "Aucun passif trouvé.",
      lastUpdated: "Dernière mise à jour",
      daysAgo: "il y a {{count}} jours",
      updatePrice: "Mettre à jour le prix",
      editTerms: "Modifier les conditions",
      errorLoading: "Échec du chargement des données d'actifs. Veuillez réessayer.",
    },
    profile: {
      title: "Profil",
      subtitle: "Gérez vos informations personnelles",
    },
  },

  // Form fields and validation
  forms: {
    required: "Ce champ est obligatoire",
    invalidEmail: "Veuillez entrer une adresse email valide",
    passwordLength: "Le mot de passe doit comporter au moins 8 caractères",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    invalidAmount: "Veuillez entrer un montant valide",
    invalidDate: "Veuillez entrer une date valide",
    maxLength: "Longueur maximale dépassée",
    minLength: "Longueur minimale requise",
    selectOption: "Veuillez sélectionner une option",
    invalidInput: "Entrée invalide",
  },

  // Dashboard cards and widgets
  dashboard: {
    totalBalance: "Solde total",
    income: "Revenus",
    expenses: "Dépenses",
    savings: "Épargne",
    budget: "Budget",
    recentTransactions: "Transactions récentes",
    cashFlow: "Flux de trésorerie",
    netWorth: "Valeur nette",
    spendingByCategory: "Dépenses courantes par catégorie",
    topCategories: "Principales catégories",
    monthlyComparison: "Comparaison mensuelle",
    viewAll: "Voir tout",
    viewMore: "Voir plus",
    seeAll: "Tout voir",
    welcome: "Bon retour, {{name}}",
    quickActions: "Actions rapides",
    commonTasks: "Tâches courantes",
    syncedAccounts: "Comptes synchronisés",
    connected: "connectés",
    allCurrent: "tous à jour",
    noAccountsConnected: "Aucun compte connecté pour le moment",
    connectMoreAccounts: "Connecter plus de comptes",
    allConnectedAccounts: "Tous les comptes connectés",
    noTransactionsYet: "Aucune transaction pour le moment",
    viewAllTransactions: "Voir toutes les transactions",
    live: "En direct",
    actionNeeded: "Action requise",
  },

  // Charts and graphs
  charts: {
    period: "Période",
    value: "Valeur",
    change: "Variation",
    percentage: "Pourcentage",
    currency: "Devise",
    category: "Catégorie",
    amount: "Montant",
    date: "Date",
    trend: "Tendance",
    average: "Moyenne",
    total: "Total",
    count: "Nombre",
    min: "Minimum",
    max: "Maximum",
    distribution: "Distribution",
    comparison: "Comparaison",
  },

  // Asset Types
  assetTypes: {
    Equity: {
      name: "Actions",
      description: "Actions, ETF et autres titres de capitaux propres"
    },
    Crypto: {
      name: "Crypto-monnaies",
      description: "Bitcoin, Ethereum et autres crypto-monnaies"
    },
    RealEstate: {
      name: "Immobilier",
      description: "Propriétés résidentielles et commerciales"
    },
    Bonds: {
      name: "Obligations",
      description: "Obligations d'État et d'entreprise"
    },
    PensionPlan: {
      name: "Plan de retraite",
      description: "Plans de retraite et pensions"
    },
    Stocks: {
      name: "Actions",
      description: "Actions d'entreprises individuelles"
    },
    Funds: {
      name: "Fonds",
      description: "Fonds communs de placement et fonds d'investissement"
    },
    ETFs: {
      name: "ETFs",
      description: "Fonds négociés en bourse"
    },
    Cash: {
      name: "Espèces",
      description: "Espèces et équivalents"
    },
    Collectible: {
      name: "Collections",
      description: "Art, collections et autres objets uniques"
    },
    Vehicle: {
      name: "Véhicules",
      description: "Voitures, bateaux et autres véhicules"
    },
    Other: {
      name: "Autres",
      description: "Autres actifs divers"
    }
  },

  // Transaction types and categories
  transactions: {
    income: "Revenus",
    expense: "Dépense",
    transfer: "Virement",
    investment: "Investissement",
    withdrawal: "Retrait",
    deposit: "Dépôt",
    payment: "Paiement",
    refund: "Remboursement",
    fee: "Frais",
    tax: "Impôt",
    dividend: "Dividende",
    interest: "Intérêt",
    sale: "Vente",
    purchase: "Achat",
    other: "Autre",
    housing: "Logement",
    food: "Alimentation",
    transportation: "Transport",
    utilities: "Services publics",
    healthcare: "Santé",
    personal: "Personnel",
    entertainment: "Divertissement",
    education: "Éducation",
    investments: "Investissements",
    ventures: "Entreprises",
  },

  // Financial Summary specific
  financialSummary: {
    revenue: "Revenus",
    assetTransfer: "Transfert d'actifs",
    housingUtilities: "Logement & Services",
    livingExpenses: "Dépenses courantes",
    personalDevelopment: "Développement personnel",
    investments: "Investissements",
    housing: "Logement",
    maintenance: "Entretien",
    utilities: "Services publics",
    eatingOut: "Restaurants",
    eatingIn: "Alimentation",
    healthBeauty: "Santé & Beauté",
    shopping: "Shopping",
    entertainment: "Divertissement",
    travel: "Voyages",
    education: "Éducation",
    skills: "Compétences",
    international: "International",
    domestic: "National",
    laborIncome: "Revenus du travail",
    taxes: "Impôts",
    ventures: "Entreprises",
    angelInvestments: "Investissements d'amorçage",
    variableIncome: "Revenus variables",
    gambling: "Jeux de hasard",
    margin: "marge",
    netIncome: 'Revenu net',
    discretionaryIncome: 'Revenu Discrétionnaire',
    savingsCapacity: "Capacité d'Épargne",
    netSavings: 'Épargne Nette',
    otherActivity: 'Autre Activité',
    netInvested: "Investissement net",
    netInvestedTooltip: "Argent placé en investissements moins l'argent retiré (ventes, retraits). Une valeur positive signifie que vous avez investi plus que vous n'avez retiré. Ce n'est ni un gain ni une perte.",
    netDebtRepaid: "Dette nette remboursée",
    netDebtRepaidTooltip: "Dette remboursée moins les nouveaux emprunts (par exemple, un prêt versé par votre banque). Une valeur positive signifie que vous avez réduit votre dette.",
    quarters: {
      q1: "T1",
      q2: "T2",
      q3: "T3",
      q4: "T4",
    },
  },

  // UI elements
  ui: {
    darkMode: "Mode sombre",
    lightMode: "Mode clair",
    systemMode: "Mode système",
    close: "Fermer",
    open: "Ouvrir",
    collapse: "Réduire",
    expand: "Développer",
    refresh: "Actualiser",
    retry: "Réessayer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    warning: "Avertissement",
    info: "Information",
    notification: "Notification",
    alert: "Alerte",
    dialogElement: "Boîte de dialogue",
    modal: "Modal",
    modalDialog: "Boîte de dialogue",
    drawer: "Tiroir",
    toast: "Toast",
    tooltipElement: "Info-bulle",
    badge: "Badge",
    avatar: "Avatar",
    icon: "Icône",
    button: "Bouton",
    input: "Champ",
    select: "Sélecteur",
    checkbox: "Case à cocher",
    radio: "Radio",
    toggle: "Bascule",
    slider: "Curseur",
    range: "Plage",
    datepicker: "Sélecteur de date",
    timepicker: "Sélecteur d'heure",
    colorpicker: "Sélecteur de couleur",
    filepicker: "Sélecteur de fichier",
    pagination: "Pagination",
    table: "Tableau",
    list: "Liste",
    card: "Carte",
    tabs: "Onglets",
    accordion: "Accordéon",
    menu: "Menu",
    dropdown: "Menu déroulant",
    popover: "Fenêtre contextuelle",
    breadcrumb: "Fil d'Ariane",
    navigation: "Navigation",
    sidebar: "Barre latérale",
    header: "En-tête",
    footer: "Pied de page",
    content: "Contenu",
    layout: "Mise en page",
    gridLayout: "Grille",
    column: "Colonne",
    row: "Ligne",
    section: "Section",
    container: "Conteneur",
    wrapper: "Enveloppe",
    box: "Boîte",
    flexbox: "Flexbox",
    stack: "Pile",
    group: "Groupe",
    divider: "Séparateur",
    spacer: "Espaceur",
    separator: "Séparateur",
    spinner: "Chargement",
    progress: "Progression",
    skeleton: "Squelette",
    placeholder: "Espace réservé",
    empty: "Vide",
    fallback: "Alternative",
    errorState: "Erreur",
    successState: "Succès",
    warningState: "Avertissement",
    infoState: "Information",
    across: "Sur",
    upgradeToPro: "Passer à Pro",
    upgradeDescription: "Obtenez des analyses et fonctionnalités avancées",
    upgradeNow: "Mettre à niveau",
    edit: "Modifier",
    delete: "Supprimer",
    deleting: "Suppression...",
    cancel: "Annuler",
    clearFilters: "Effacer les filtres",
    dialog: {
      deleteTitle: "Supprimer {{entity}}",
      deleteConfirmation: "Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action ne peut pas être annulée."
    },
    entity: {
      category: "catégorie",
      account: "compte",
      transaction: "transaction"
    },
  },

  // Notifications and alerts
  notifications: {
    success: {
      saved: "Enregistré avec succès",
      updated: "Mis à jour avec succès",
      deleted: "Supprimé avec succès",
      created: "Créé avec succès",
      uploaded: "Téléchargé avec succès",
      sent: "Envoyé avec succès",
      imported: "Importé avec succès",
      exported: "Exporté avec succès",
      downloaded: "Téléchargé avec succès",
      submitted: "Soumis avec succès",
    },
    error: {
      general: "Une erreur est survenue",
      notFound: "Non trouvé",
      serverError: "Erreur du serveur",
      validation: "Erreur de validation",
      unauthorized: "Non autorisé",
      forbidden: "Interdit",
      conflict: "Conflit",
      network: "Erreur réseau",
      generic: "Une erreur est survenue. Veuillez réessayer.",
      server: "Erreur serveur. Veuillez réessayer plus tard.",
      timeout: "Requête expirée. Veuillez réessayer.",
      badRequest: "Requête incorrecte. Veuillez vérifier vos entrées.",
      unavailable: "Service indisponible. Veuillez réessayer plus tard.",
      tooManyRequests: "Trop de requêtes. Veuillez réessayer plus tard.",
    },
    warning: {
      unsavedChanges: "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?",
      unsaved: "Modifications non enregistrées",
      deleteConfirmation: "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action ne peut pas être annulée.",
      logout: "Êtes-vous sûr de vouloir vous déconnecter ?",
      incomplete: "Certains champs sont incomplets",
      limitReached: "Vous avez atteint la limite.",
      lowBalance: "Votre solde est bas.",
      expiringSoon: "Expire bientôt.",
    },
    info: {
      noResults: "Aucun résultat trouvé.",
      empty: "Aucun élément à afficher.",
      loading: "Chargement...",
      processingRequest: "Traitement de votre demande...",
      newVersion: "Une nouvelle version est disponible.",
      comingSoon: "Bientôt disponible !",
      maintenance: "Maintenance programmée.",
    },
    center: {
      title: "Notifications",
      allCaughtUp: "Tout est à jour",
    },
  },

  accountForm: {
    accountName: "Nom du compte",
    accountNumber: "Numéro de compte",
    bank: "Banque / Institution",
    currency: "Devise",
    country: "Pays",
    accountCreated: "Compte créé",
    accountCreatedSuccess: "{{name}} a été ajouté à vos comptes.",
    accountUpdated: "Compte mis à jour",
    accountUpdatedSuccess: "Le compte a été mis à jour avec succès.",
    createAccount: "Créer un compte",
    updateAccount: "Mettre à jour le compte",
    createError: "Échec de la création du compte. Veuillez réessayer.",
    updateError: "Échec de la mise à jour du compte. Veuillez réessayer.",
    selectBank: "Sélectionnez une banque",
    selectCurrency: "Sélectionnez une devise",
    selectCountry: "Sélectionnez un pays",
    addBank: "Ajouter une nouvelle banque",
    addBankError: "Échec de l'ajout de la banque. Veuillez réessayer.",
  },
  addBankDialog: {
    title: "Ajouter une nouvelle banque",
    description: "Saisissez le nom de la banque que vous souhaitez ajouter.",
    nameLabel: "Nom de la banque",
    namePlaceholder: "p. ex. Chase, Monzo, Revolut",
    validationError: "Le nom de la banque doit contenir entre 2 et 100 caractères.",
  },
  categoryForm: {
    name: "Nom de la catégorie",
    type: "Type",
    group: "Groupe",
    categoryCreated: "Catégorie créée",
    categoryCreatedSuccess: "{{name}} a été ajoutée à vos catégories.",
    categoryUpdated: "Catégorie mise à jour",
    categoryUpdatedSuccess: "La catégorie a été mise à jour avec succès.",
    createCategory: "Créer une catégorie",
    updateCategory: "Mettre à jour la catégorie",
    createError: "Échec de la création de la catégorie. Veuillez réessayer.",
    updateError: "Échec de la mise à jour de la catégorie. Veuillez réessayer.",
  },
  transactionForm: {
    date: "Date",
    transactionType: "Type de transaction",
    description: "Description",
    amount: "Montant",
    fromAccount: "Depuis le compte",
    account: "Compte",
    toAccount: "Vers le compte",
    category: "Catégorie",
    notes: "Notes (optionnel)",
    transactionCreated: "Transaction créée",
    transactionCreatedSuccess: "Nouvelle transaction enregistrée.",
    transactionUpdated: "Transaction mise à jour",
    transactionUpdatedSuccess: "La transaction a été mise à jour avec succès.",
    createTransaction: "Créer une transaction",
    updateTransaction: "Mettre à jour la transaction",
    createError: "Échec de la création de la transaction. Veuillez réessayer.",
    updateError: "Échec de la mise à jour de la transaction. Veuillez réessayer.",
  },
  userForm: {
    email: "Email",
    userCreated: "Utilisateur créé",
    userCreatedSuccess: "{{email}} a été invité dans votre équipe.",
    userUpdated: "Utilisateur mis à jour",
    userUpdatedSuccess: "L'utilisateur a été mis à jour avec succès.",
    inviteUser: "Inviter un utilisateur",
    updateUser: "Mettre à jour l'utilisateur",
    createError: "Erreur lors de la création de l'utilisateur. Veuillez réessayer.",
    updateError: "Erreur lors de la mise à jour de l'utilisateur. Veuillez réessayer.",
  },

  defaultCategories: {
    names: {
      OPERATING_CASH: "Trésorerie",
      STOCKS: "Actions",
      INVESTMENT_FUNDS: "Fonds",
      ETFS: "ETFs",
      COPY_TRADING: "Copy Trading",
      PENSION_PLAN: "Plan de retraite",
      GOVERNMENT_BONDS: "Obligations d'État",
      CORPORATE_BONDS: "Obligations d'entreprise",
      CRYPTO: "Crypto-monnaies",
      REAL_ESTATE: "Immobilier",
      COLLECTIBLE: "Collections",
      VEHICLE: "Véhicule",
      COMMODITIES: "Matières premières",
      PRIVATE_EQUITY: "Capital investissement",
      MORTGAGE: "Hypothèque",
      CREDIT_CARD_DEBT: "Dette de carte de crédit",
      ALLOWANCE: "Allocation",
      RENT_INCOME: "Revenus locatifs",
      SALARY: "Salaire",
      FREELANCE_INCOME: "Revenus de Freelance",
      BONUS: "Prime",
      COMMISSION: "Commission",
      GOVERNMENT_WELFARE: "Aides gouvernementales",
      TAXES: "Impôts",
      TAX_REFUND: "Remboursement d'Impôts",
      DIVIDENDS: "Dividendes",
      BOND_INCOME: "Revenus obligataires",
      INTEREST_INCOME: "Revenus d'intérêts",
      OPTIONS_INCOME: "Revenus d'options",
      RENT: "Loyer",
      HOA_COMMUNITY_FEES: "Charges de copropriété",
      SECURITY_DEPOSIT: "Dépôt de garantie",
      HOME_INSURANCE: "Assurance habitation",
      POWER_AND_GAS: "Électricité et gaz",
      WATER: "Eau",
      DATA_PLAN: "Forfait mobile",
      INTERNET: "Internet",
      CLEANING_SERVICE: "Service de ménage",
      HOME_IMPROVEMENT: "Travaux de maison",
      GROCERIES: "Courses",
      CONVENIENCE_STORES: "Supérettes",
      DOCTOR: "Médecin",
      HEALTH_INSURANCE: "Assurance maladie",
      PHARMACY: "Pharmacie",
      BIKING: "Vélo",
      FUEL_AND_GAS: "Carburant",
      VEHICLE_MAINTENANCE: "Entretien du véhicule",
      VEHICLE_TAXES_AND_TICKETS: "Taxes et amendes véhicule",
      VEHICLE_INSURANCE: "Assurance véhicule",
      METRO: "Métro",
      PARKING: "Parking",
      TAXI: "Taxi",
      TRAINS: "Trains",
      BUS: "Bus",
      PET_CARE: "Soins des animaux",
      PET_FOOD: "Nourriture animale",
      PET_INSURANCE: "Assurance animale",
      BANKING_FEES: "Frais bancaires",
      DOCUMENTATION: "Documentation",
      NOTARY: "Notaire",
      ACCOUNTING: "Comptabilité",
      BUSINESS_MEAL: "Repas d'affaires",
      RESTAURANTS: "Restaurants",
      BAKERY_AND_COFFEE: "Boulangerie et café",
      FOOD_DELIVERY: "Livraison de repas",
      BAR: "Bar",
      NIGHTCLUB: "Boîte de nuit",
      CONCERTS: "Concerts",
      MOVIES_AND_THEATER: "Cinéma et théâtre",
      OUTDOOR_ACTIVITIES: "Activités de plein air",
      SPORTING_EVENTS: "Événements sportifs",
      GAMBLING: "Jeux de hasard",
      GAMING: "Jeux vidéo",
      BEAUTY: "Beauté",
      HAIRCARE: "Coiffure",
      SPORTS_AND_GYM: "Sport et gym",
      SHOPPING: "Shopping",
      ELECTRONICS: "Électronique",
      FURNITURE_AND_DIY: "Meubles et bricolage",
      CLOTHES_AND_FASHION: "Vêtements et mode",
      GIFTS: "Cadeaux",
      JEWELRY: "Bijoux",
      DECORATION_AND_TEXTILES: "Décoration et textiles",
      KITCHENWARE: "Ustensiles de cuisine",
      SOFTWARE: "Logiciels",
      CONTENT_AND_MEDIA: "Contenu et médias",
      LOYALTY_PROGRAMS: "Programmes de fidélité",
      CASH_AT_ATM: "Retrait distributeur",
      INHERITANCE: "Héritage",
      RECEIVED_DOMESTIC: "Virement Reçu — National",
      RECEIVED_INTERNATIONAL: "Virement Reçu — International",
      SENT_DOMESTIC: "Virement Envoyé — National",
      SENT_INTERNATIONAL: "Virement Envoyé — International",
      BIZ_SALES_REVENUE: "Chiffre d'affaires",
      BIZ_SERVICE_REVENUE: "Revenus de services",
      BIZ_REFERRAL_INCOME: "Parrainage et affiliation",
      BIZ_INVENTORY: "Inventaire et matériaux",
      BIZ_SHIPPING: "Expédition et logistique",
      BIZ_SAAS: "SaaS et outils",
      BIZ_CLOUD: "Cloud et hébergement",
      BIZ_MARKETING: "Marketing et publicité",
      BIZ_DATA_SERVICES: "Données et services API",
      BIZ_OFFICE: "Bureau et espace de travail",
      BIZ_DOMAINS: "Domaines et licences",
      BIZ_EQUIPMENT: "Équipement professionnel",
      BIZ_OTHER_COSTS: "Autres frais professionnels",
      BIZ_FREELANCERS: "Freelances et sous-traitants",
      BIZ_PROFESSIONAL_SERVICES: "Services professionnels",
      BIZ_TAXES: "Taxes et TVA professionnelles",
      BIZ_CAPITAL: "Injection de capital",
      MUSIC: "Instruments de musique",
      THERAPY_AND_COUNSELING: "Thérapie et accompagnement",
      MENTORING: "Coaching et mentorat",
      SCHOOL: "École",
      ONLINE_COURSES: "Cours en ligne",
      TRAVEL_TRANSPORT: "Transport de voyage",
      ACCOMMODATION: "Hébergement",
      CAR_RENTAL: "Location de voiture",
      TOURS_AND_ACTIVITIES: "Excursions et activités",
      TRAVEL_EXPENSES: "Frais de voyage",
      DONATIONS: "Dons",
      BOOKS: "Livres",
    },
    descriptions: {
      SENT_DOMESTIC: "Argent envoyé à quelqu'un dans votre pays — remboursements à des amis, virements entre vos propres comptes, ou tout débit non lié à un achat.",
      SENT_INTERNATIONAL: "Argent envoyé à l'étranger — virements à la famille, à vos propres comptes à l'étranger, ou tout débit transfrontalier non lié à un achat.",
      RECEIVED_DOMESTIC: "Argent reçu de quelqu'un dans votre pays — remboursements d'amis, virements entre vos propres comptes, ou autres crédits non liés à un revenu.",
      RECEIVED_INTERNATIONAL: "Argent reçu de l'étranger — cadeaux de la famille, virements de vos propres comptes à l'étranger, ou autres crédits transfrontaliers non liés à un revenu.",
      BIZ_SERVICE_REVENUE: "Revenus de services rendus par votre propre entreprise ou projet secondaire. Si le freelance est votre activité principale plutôt qu'une activité secondaire, utilisez Revenus de Freelance (dans Revenus du Travail) à la place.",
      BIZ_SALES_REVENUE: "Revenus des ventes de biens par votre propre entreprise ou projet secondaire.",
      BIZ_OTHER_REVENUE: "Autres sources de revenus de votre propre entreprise ou projet secondaire — licences, redevances, paiements de partenaires, etc.",
      ALLOWANCE: "Argent de poche, allocations parentales ou soutien familial continu. Utile pour les étudiants et les déploiements de Bliss en classe où les utilisateurs suivent l'argent reçu de leur famille.",
      GOVERNMENT_WELFARE: "Paiements de transfert du gouvernement — allocations chômage, allocations familiales, sécurité sociale, etc. Ce ne sont pas des revenus du travail.",
      INHERITANCE: "Argent ou biens hérités d'un membre de la famille décédé. Classé dans les Virements car il s'agit d'un revenu exceptionnel ponctuel, ni du travail ni d'un investissement — le garder ici évite de fausser les tendances annuelles de revenus.",
      FREELANCE_INCOME: "Revenus de freelance ou de conseil traités comme votre activité principale. Si le travail est une activité secondaire avec sa propre comptabilité, utilisez Revenus de Services (dans Entreprises) à la place.",
      BONUS: "Primes annuelles, trimestrielles ou ponctuelles versées par votre employeur. Souvent imposées différemment du salaire régulier — la séparer facilite la lecture des tendances de revenus.",
      COMMISSION: "Commissions sur les ventes ou autre rémunération basée sur la performance liée aux revenus que vous avez générés.",
      TAX_REFUND: "Remboursement reçu de l'administration fiscale pour un trop-payé sur une période antérieure.",
    },
    groups: {
      Cash: "Trésorerie",
      Stocks: "Actions",
      Funds: "Fonds",
      ETFs: "ETFs",
      "Pension Plan": "Plan de retraite",
      Bonds: "Obligations",
      Crypto: "Crypto-monnaies",
      "Real Estate": "Immobilier",
      Collectible: "Collections",
      "Depreciating assets": "Actifs dépréciables",
      Commodities: "Matières premières",
      "Private Equity": "Capital investissement",
      "Real Estate Loan": "Prêt immobilier",
      "Personal Debt": "Dette personnelle",
      "Passive Income": "Revenus passifs",
      "Labor Income": "Revenus du travail",
      Taxes: "Impôts",
      Housing: "Logement",
      Utilities: "Services publics",
      "Home Maintenance": "Entretien de la maison",
      "Eating In": "Manger à la maison",
      Healthcare: "Santé",
      Transportation: "Transport",
      Pets: "Animaux",
      Finance: "Finance",
      Civil: "Civil",
      "Dining Out": "Restaurants",
      Entertainment: "Divertissement",
      "Wellness & Beauty": "Bien-être et beauté",
      "Shopping & Gifts": "Shopping et cadeaux",
      Subscriptions: "Abonnements",
      Misc: "Divers",
      Inheritance: "Héritage",
      Domestic: "National",
      International: "International",
      Revenue: "Revenus",
      "Cost of Goods Sold": "Coût des marchandises",
      "Operating Expenses": "Charges d'exploitation",
      "People & Services": "Personnel et services",
      Capital: "Capital",
      Skills: "Compétences",
      "Mental Health": "Santé mentale",
      Education: "Éducation",
      Travel: "Voyages",
      Donations: "Dons",
      Other: "Autre",
      Others: "Autres",
      "N/A": "N/A",
    },
    types: {
      Income: "Revenus",
      Essentials: "Essentiels",
      Lifestyle: "Style de vie",
      Growth: "Croissance",
      Ventures: "Entreprises",
      Investments: "Investissements",
      Asset: "Actif",
      Debt: "Dette",
      Transfers: "Virements",
    },
    processingHints: {
      API_STOCK: "API prix actions",
      API_CRYPTO: "API prix crypto",
      API_FUND: "API prix fonds",
      AMORTIZING_LOAN: "Suivi de prêt",
      SIMPLE_LIABILITY: "Suivi de passif",
      CASH: "Suivi de trésorerie",
      MANUAL: "Manuel",
      TAX_DEDUCTIBLE: "Déductible d'impôts",
      DEBT: "Suivi de dette",
      COPY_TRADING: "Copy Trading eToro",
    },
  },

  accountsPage: {
    title: "Comptes",
    subtitle: "Gérez vos connexions bancaires et comptes manuels.",
    connectBank: "Connecter une banque",
    addManual: "Ajouter un compte manuel",
    selectAccount: "Sélectionnez un compte",
    selectAccountHint: "Choisissez un compte dans la liste pour voir les détails de connexion, les journaux de synchronisation et les actions de gestion.",
    deleteTitle: "Supprimer le compte",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer \"{{name}}\" ? Cette action est irréversible.",
    deleteSuccess: "Compte supprimé",
    deleteSuccessDetail: "{{name}} a été supprimé.",
    deleteFailed: "Échec de la suppression du compte",
    deleteAction: "Supprimer le compte",
    dangerZone: "Zone de danger",
    deleteBlockedTransactions_one: "Ce compte a {{count}} transaction liée et ne peut pas être supprimé tant qu'elle n'a pas été supprimée ou réattribuée à un autre compte.",
    deleteBlockedTransactions_other: "Ce compte a {{count}} transactions liées et ne peut pas être supprimé tant qu'elles n'ont pas été supprimées ou réattribuées à un autre compte.",
    deleteBlockedTransactions: "Ce compte a {{count}} transactions liées et ne peut pas être supprimé tant qu'elles n'ont pas été supprimées ou réattribuées à un autre compte.",
    deleteBlockedPlaid: "Ce compte est toujours connecté à votre banque. Déconnectez d'abord la connexion bancaire, puis supprimez le compte.",
    deleteBlockedPlaidHint: "Déconnectez d'abord cette connexion bancaire (utilisez « Suspendre la synchronisation » ci-dessus) avant de supprimer le compte.",
    deleteUnknownError: "Impossible de supprimer ce compte. Veuillez réessayer.",
    searchAccounts: "Rechercher des comptes...",
    noAccountsMatch: "Aucun compte ne correspond à votre recherche.",
    noAccountsYet: "Aucun compte pour le moment.",
    synced: "Synchronisé",
    actionRequired: "Action requise",
    disconnected: "Déconnecté",
    manual: "Manuel",
  },

  accountDetail: {
    edit: "Modifier",
    plaidConnected: "Connecté par Plaid",
    placeholderNumberHint: "Ce compte a encore un numéro provisoire issu de la configuration.",
    addAccountNumber: "Ajouter le vrai numéro de compte",
    connectionHealth: "État de la connexion",
    consentExpired: "Consentement expiré",
    consentExpiringSoon: "Consentement bientôt expiré",
    consentExpiredOn: "Votre consentement bancaire a expiré le {{date}}. Reconnectez pour reprendre la synchronisation.",
    consentExpiresOn: "Votre consentement bancaire expire le {{date}} ({{days}} jour restant). Reconnectez avant pour éviter toute interruption.",
    consentExpiresOnPlural: "Votre consentement bancaire expire le {{date}} ({{days}} jours restants). Reconnectez avant pour éviter toute interruption.",
    reconnect: "Reconnecter",
    disconnectedMessage: "Cette connexion bancaire a été déconnectée. Reliez-la pour reprendre la synchronisation des transactions.",
    reconnectBank: "Reconnecter la banque",
    actions: "Actions",
    resyncNow: "Resynchroniser",
    rotateToken: "Rotation du token",
    relinkPlaid: "Relier Plaid",
    pauseSync: "Suspendre la synchronisation",
    security: "Sécurité",
    securityEncryption: "Toutes les données du compte sont chiffrées au repos avec AES-256-GCM.",
    securityTokens: "Les tokens d'accès Plaid sont régulièrement renouvelés et stockés chiffrés.",
    pauseSyncDescription: "Cela suspendra la synchronisation de ce compte. Vos transactions existantes et l'historique de connexion ne seront pas affectés. Vous pouvez reconnecter à tout moment.",
    disconnect: "Déconnecter",
    disconnecting: "Déconnexion...",
    syncTriggered: "Synchronisation lancée",
    syncTriggeredDetail: "Une nouvelle synchronisation a été démarrée pour ce compte.",
    syncFailed: "Échec du lancement de la synchronisation",
    tokenRotated: "Token renouvelé",
    tokenRotatedDetail: "Le token d'accès a été renouvelé avec succès.",
    tokenRotateFailed: "Échec de la rotation du token",
    disconnected: "Déconnecté",
    disconnectedDetail: "La connexion bancaire a été supprimée.",
    disconnectFailed: "Échec de la déconnexion",
    securityDesc: "Toutes les données du compte sont chiffrées au repos avec AES-256-GCM.",
    securityPlaid: "Les tokens d'accès Plaid sont régulièrement renouvelés et stockés chiffrés.",
    syncTriggeredDesc: "Une nouvelle synchronisation a été démarrée pour ce compte.",
    tokenRotatedDesc: "Le token d'accès a été renouvelé avec succès.",
    disconnectedDesc: "La connexion bancaire a été supprimée.",
    reconnectDesc: "Cette connexion bancaire a été déconnectée. Reliez-la pour reprendre la synchronisation des transactions.",
    pauseSyncTitle: "Suspendre la synchronisation",
    pauseSyncDesc: "Cela suspendra la synchronisation de ce compte. Vos transactions existantes et l'historique de connexion ne seront pas affectés. Vous pouvez reconnecter à tout moment.",
    consentExpiredDesc: "Votre consentement bancaire a expiré le {{date}}. Reconnectez pour reprendre la synchronisation.",
    consentExpiringSoonDesc: "Votre consentement bancaire expire le {{date}} ({{days}} jours restants). Reconnectez avant pour éviter toute interruption.",
  },

  accountModal: {
    editTitle: "Modifier le compte",
    addTitle: "Ajouter un compte manuel",
    editDescription: "Mettez à jour les détails de votre compte.",
    addDescription: "Ajoutez un nouveau compte à suivi manuel.",
  },

  connectionHealth: {
    status: "Statut",
    lastSynced: "Dernière synchronisation",
    nextSync: "Prochaine synchronisation",
    approxInterval: "~6 heures",
    historyRange: "Plage d'historique",
    notYetSynced: "Pas encore synchronisé",
    historyStatus: "État de l'historique",
    complete: "Complet",
    syncingHistory: "Synchronisation de l'historique complet...",
    institutionId: "ID de l'institution",
    connection: "Connexion",
    manualEntry: "Saisie manuelle",
    fetchOlder: "Récupérer les transactions anciennes",
    selectStartDate: "Sélectionnez une date de début (jusqu'à 2 ans en arrière)",
    fetchFrom: "Récupérer à partir de",
    selectDate: "Sélectionner une date",
    title: "État de la connexion",
    backfillStarted: "Récupération lancée",
    backfillDetail: "Récupération des transactions depuis le {{date}}. Cela peut prendre un moment.",
    backfillFailed: "Échec du lancement de la récupération",
    nextSyncValue: "~6 heures",
    fetching: "Récupération...",
    never: "Jamais",
    justNow: "À l'instant",
    minutesAgo: "il y a {{count}}m",
    hoursAgo: "il y a {{count}}h",
    daysAgo: "il y a {{count}}j",
    today: "Aujourd'hui",
    fetchOlderTransactions: "Récupérer les transactions plus anciennes",
  },

  review: {
    confident: "Fiable",
    newMerchant: "Nouveau commerçant",
    actionNeeded: "Action requise",
    uncertain: "Incertaine",
    duplicate: "Doublon",
    possibleDup: "Doublon possible",
    approveAll: "Tout approuver",
    date: "Date",
    merchant: "Commerçant",
    account: "Compte",
    amount: "Montant",
    confidence: "Conf.",
    status: "Statut",
    actions: "Actions",
    uncategorized: "Non catégorisé",
    required: "Requis",
    selectAccount: "Sélectionner un compte",
    noAccount: "Aucun compte",
    investmentEnrichmentRequired: "Les informations d'investissement sont requises pour cette catégorie. Veuillez renseigner le ticker, la quantité et le prix.",
    investmentEnrichmentRequiredTickerOptional: "Les informations d'investissement sont requises pour cette catégorie. Renseignez la quantité et le prix ; le ticker est facultatif pour les fonds non cotés.",
    currencyMismatch: "Cet actif est coté en {{assetCurrency}} mais la transaction est en {{txCurrency}}. Les valeurs du portefeuille peuvent nécessiter une conversion de devise.",
    detailsNotes: "Détails / Notes",
    optionalNotes: "Notes optionnelles",
    tags: "Étiquettes",
    skip: "Passer",
    merchantHistory: "Historique du commerçant",
    noMerchantHistory: "Aucune transaction précédente trouvée pour ce commerçant.",
    blissAnalysis: "Analyse Bliss",
    aiConfidence: "Confiance IA",
    source: "Source",
    plaidCategory: "Catégorie Plaid",
    classificationReasoning: "Raisonnement de classification",
    whyChose: "Pourquoi j'ai choisi cela",
    sourceLabels: {
      USER_OVERRIDE: "Défini par vous",
      EXACT_MATCH: "Correspondance de l'historique",
      VECTOR_MATCH: "Similaire à votre historique",
      VECTOR_MATCH_GLOBAL: "Correspondance de la communauté",
      LLM: "Classification par IA",
      PLAID_HINT: "Suggéré par la banque",
      default: "Analyse IA",
    },
    enrichmentRequired: "Informations requises",
    enrichmentDescription: "Cette transaction semble liée à un investissement. Veuillez fournir les détails ci-dessous pour un suivi correct dans votre portefeuille.",
    tickerSymbol: "Symbole du ticker",
    tickerOptional: "facultatif",
    tickerPlaceholder: "ex. VWCE, AAPL",
    pricePerShare: "Prix par action",
    pricePlaceholder: "ex. 43.67",
    quantity: "Quantité",
    quantityAuto: "(auto)",
    quantityCalculated: "Calculé automatiquement",
    quantityPlaceholder: "ex. 1.23",
    notesPlaceholder: "Notes optionnelles (remplace la description par défaut de la transaction)",
    selectCategory: "Veuillez sélectionner une catégorie",
    selectDate: "Veuillez sélectionner une date",
    descriptionRequired: "La description est obligatoire",
    selectCurrency: "Veuillez sélectionner une devise",
    selectAccountValidation: "Veuillez sélectionner un compte",
    pageTitle: "Revue des Transactions",
    pageSubtitle: "Révisez et approuvez les transactions en attente de toutes les sources.",
    requeueSkipped: "Remettre en file les ignorées",
    bulkPromote: "Promotion en masse",
    reviewedProgress: "{{done}} sur {{total}} révisées",
    allPending: "Toutes en attente",
    fromPlaid: "De Plaid",
    fromImports: "Des Importations",
    allCaughtUp: "Tout est à jour !",
    noPendingTransactions: "Aucune transaction en attente à réviser.",
    plaidTransactions: "Transactions Plaid",
    importTransactions: "Transactions d'importation",
    pending: "en attente",
    cancelImport: "Annuler l'importation",
    noPlaidToReview: "Aucune transaction Plaid à réviser",
    allPlaidProcessed: "Toutes les transactions Plaid ont été traitées.",
    noPendingImports: "Aucune importation en attente",
    allImportsCommitted: "Toutes les importations ont été validées.",
    committingTransactions: "Validation des transactions...",
    complete: "terminé",
    noRowsInImport: "Aucune ligne dans cette importation.",
    committing: "Validation...",
    commitAll: "Tout valider",
    selectCategoryPlaceholder: "Sélectionner une catégorie",
    saveChanges: "Enregistrer les modifications",
    saveAndPromote: "Enregistrer et promouvoir",
    resetToPending: "Revenir à En attente",
    resetToPendingDesc: "Remet cette ligne en attente pour éviter la validation automatique. Utile pour annuler une classification auto-promue que vous souhaitez réexaminer.",
    bulkPromoteTitle: "Promotion en masse des transactions",
    bulkPromoteDescription: "Promouvoir automatiquement toutes les transactions Plaid classifiées dépassant le seuil de confiance.",
    minConfidenceThreshold: "Seuil de confiance minimum",
    threshold90: "90% (Le plus conservateur)",
    threshold80: "80% (Recommandé)",
    threshold70: "70%",
    threshold50: "50% (Le moins conservateur)",
    thresholdHint: "Seules les transactions dont la confiance IA est égale ou supérieure à ce seuil seront promues.",
    promoteAll: "Tout promouvoir",
    promoting: "Promotion...",
    promoteMatchingTitle: "Promouvoir les transactions correspondantes ?",
    promoteMatchingDescription: "<strong>{{count}} transaction(s) en attente</strong> trouvée(s) nommée(s) \"{{description}}\".",
    justThisOne: "Celle-ci uniquement",
    promoteAllCount: "Promouvoir les {{count}}",
    confirmMatchingTitle: "Confirmer aussi les transactions correspondantes ?",
    confirmMatchingDescription: "Il y a <strong>{{count}} autre(s) transaction(s) en attente</strong> nommée(s) \"{{description}}\". Les confirmer toutes comme <strong>{{category}}</strong> ?",
    confirmAllCount: "Confirmer les {{count}}",
    confirming: "Confirmation...",
    pageOf: "Page {{current}} sur {{total}}",
    unknown: "Inconnu",
    // Échec de classification et nouvelle tentative
    classificationFailed: "Échec de la classification",
    retryClassification: "Réessayer la classification",
    failedTransactionsBanner: "{{count}} transaction(s) en échec de classification",
    retrySuccess: "Nouvelle tentative lancée",
    retryError: "Échec du lancement de la nouvelle tentative",
    errorTimedOut: "Le délai de classification IA a expiré — réessayez ou classez manuellement",
    errorRateLimited: "Limite de requêtes du fournisseur IA atteinte — réessayez sous peu",
    errorGeneric: "La classification IA a échoué — réessayez ou classez manuellement",
    // Smart Import hold-back reasons (#142)
    holdBack: {
      missingFields: "Manque : {{fields}}",
      fieldTicker: "ticker",
      fieldQuantity: "quantité",
      fieldPrice: "prix",
      missingAccount: "Compte manquant",
      duplicate: "Doublon",
      updateFailed: "Échec de la mise à jour",
      commitError: "Erreur de validation",
      filterLabel: "Retenues uniquement",
    },
    commitToast: {
      committedTitle: "Import validé",
      partialTitle: "Validation partielle terminée",
      created: "{{count}} créées",
      updated: "{{count}} mises à jour",
      noneCommitted: "Aucune ligne validée",
      heldBack: "{{count}} retenues : {{reasons}}",
      missingTicker_one: "{{count}} sans ticker",
      missingTicker_other: "{{count}} sans ticker",
      missingQuantity_one: "{{count}} sans quantité",
      missingQuantity_other: "{{count}} sans quantité",
      missingPrice_one: "{{count}} sans prix",
      missingPrice_other: "{{count}} sans prix",
      missingAccount_one: "{{count}} sans compte",
      missingAccount_other: "{{count}} sans compte",
      duplicate_one: "{{count}} doublon",
      duplicate_other: "{{count}} doublons",
      updateFailed_one: "{{count}} mise à jour échouée",
      updateFailed_other: "{{count}} mises à jour échouées",
      commitError_one: "{{count}} erreur de validation",
      commitError_other: "{{count}} erreurs de validation",
      stillToReview: "{{count}} encore à vérifier",
      done: "Terminé.",
    },
  },

  currencyRates: {
    title: "Taux de change",
    subtitle: "Gérez les taux de change pour les calculs financiers",
    refreshRates: "Actualiser les taux",
    addRate: "Ajouter un taux",
    searchPlaceholder: "Rechercher devises ou fournisseurs...",
    from: "De",
    to: "Vers",
    rate: "Taux",
    year: "Année",
    month: "Mois",
    day: "Jour",
    provider: "Fournisseur",
    lastUpdated: "Dernière mise à jour",
    noRatesFound: "Aucun taux trouvé",
    addTitle: "Ajouter un taux de change",
    providerOptional: "Fournisseur (optionnel)",
    adding: "Ajout...",
  },

  userManagement: {
    title: "Gestion des utilisateurs",
    subtitle: "Gérez les utilisateurs et leur accès à votre tenant",
    createUser: "Créer un utilisateur",
    createTitle: "Créer un nouvel utilisateur",
    createDescription: "Créez un nouveau compte utilisateur avec des identifiants de connexion.",
    editTitle: "Modifier l'utilisateur",
    editDescription: "Mettre à jour les informations et les permissions d'accès de l'utilisateur",
    name: "Nom",
    namePlaceholder: "Entrez son nom",
    emailAddress: "Adresse email",
    emailPlaceholder: "Entrez son adresse email",
    password: "Mot de passe",
    passwordPlaceholder: "Définir un mot de passe (min. 6 caractères)",
    role: "Rôle",
    selectRole: "Sélectionner un rôle",
    roleAdmin: "Administrateur",
    roleMember: "Membre",
    roleViewer: "Lecteur (lecture seule)",
    preferredLanguage: "Langue préférée",
    selectLanguage: "Sélectionner la langue",
    birthDate: "Date de naissance",
    cancel: "Annuler",
    updateUser: "Mettre à jour l'utilisateur",
    tenantUsers: "Utilisateurs du tenant",
    tenantUsersDescription: "Gérez les utilisateurs ayant accès à vos données financières",
    searchUsers: "Rechercher des utilisateurs...",
    statusFilter: "Statut",
    allStatuses: "Tous les statuts",
    statusActive: "Actif",
    statusPending: "En attente",
    statusInactive: "Inactif",
    showing: "Affichage de",
    of: "sur",
    users: "utilisateurs",
    user: "Utilisateur",
    lastLogin: "Dernière connexion",
    never: "Jamais",
    editUser: "Modifier l'utilisateur",
    resendInvitation: "Renvoyer l'invitation",
    removeUser: "Supprimer l'utilisateur",
    noUsersFound: "Aucun utilisateur trouvé avec les filtres appliqués",
    userCreated: "Utilisateur créé",
    userCreatedDetail: "{{name}} a été créé avec succès",
    userCreateFailed: "Une erreur est survenue lors de la création de l'utilisateur",
    userUpdated: "Utilisateur mis à jour",
    userUpdatedDetail: "{{name}} a été mis à jour avec succès",
    userUpdateFailed: "Une erreur est survenue lors de la mise à jour de l'utilisateur",
    userRemoved: "Utilisateur supprimé",
    userRemovedDetail: "L'utilisateur a été supprimé de ce tenant",
    userRemoveFailed: "Une erreur est survenue lors de la suppression de l'utilisateur",
    invitationSent: "Invitation envoyée",
    invitationSentDetail: "Une nouvelle invitation a été envoyée à {{email}}",
    invitationFailed: "Une erreur est survenue lors du renvoi de l'invitation",
    relationSelf: "Moi-même",
    relationPartner: "Partenaire",
    relationChild: "Enfant",
    relationRelative: "Autre parent",
    relationFriend: "Ami(e)",
    relationColleague: "Collègue",
    relationOther: "Autre",
  },

  equityAnalysis: {
    diversified: "Diversifié",
    etfBadge: "ETF",
    basedOn: "sur {{pct}} % de la valeur",
    unmapped: "{{pct}} % non identifiés",
    copyBadge: "Copie",
    viaCopy: "via @{{username}}",
    viaCopyIncluded: "dont {{value}} via @{{username}}",
    copyCash: "Liquidités",
    copyUnmapped: "Non identifié",
    copySplit: "{{value}} réparti en {{count}} positions",
    title: "Analyse des actions",
    subtitle: "Analysez vos placements par secteur, industrie, pays et classe d'actifs",
    totalEquityValue: "Valeur totale des actions",
    holdings: "Positions",
    avgPE: "P/E moyen",
    avgDividendYield: "Rendement div. moyen",
    groupBy: "Grouper par :",
    sector: "Secteur",
    industry: "Industrie",
    country: "Pays",
    allocationBy: "Allocation par {{grouping}}",
    noStockHoldings: "Aucune position en actions ou ETF trouvée",
    top10: "Top 10 des positions par poids",
    allHoldings: "Toutes les positions en actions et ETF",
    noHoldingsHint: "Aucune position trouvée. Ajoutez des actions ou des ETF à votre portefeuille pour voir l'analyse.",
    symbol: "Symbole",
    name: "Nom",
    pe: "P/E",
    divYield: "Rend. div.",
    eps: "BPA",
    weekRange: "Fourchette 52S",
    weight: "Poids",
    value: "Valeur",
    loadFailed: "Échec du chargement des données d'analyse des actions.",
    assetClass: "Classe d'actifs",
    lookThrough: "Transparence des ETF",
    lookThroughHint: "Répartit chaque ETF entre les secteurs et pays qu'il détient",
    lookThroughWithCopies: "Transparence des ETF et des copies",
    lookThroughHintWithCopies: "Répartit chaque ETF entre les secteurs et pays qu'il détient, et affiche chaque copie eToro comme les positions dans lesquelles elle investit",
    pendingSecurityData: "En attente des données de titre pour {{symbols}}. Ces fonds apparaîtront ici une fois récupérées.",
    lookThroughOther: "Autres",
    fixedIncomeBucket: "Obligataire",
    editAssetClass: "Modifier la classe d'actifs de {{symbol}}",
    automatic: "Automatique ({{assetClass}})",
    overrideSaved: "Classe d'actifs mise à jour",
    overrideFailed: "Impossible de mettre à jour la classe d'actifs",
    overrideHint: "Définie manuellement",
    etfBreakdown: "Principaux secteurs",
    save: "Enregistrer",
    cancel: "Annuler",
    assetClasses: {
      STOCK: "Action",
      INDEX_ETF: "ETF indiciel",
      SECTOR_ETF: "ETF sectoriel",
      BOND_ETF: "ETF obligataire",
      REIT: "SIIC / REIT",
      FUND: "Fonds",
      GOV_BOND: "Obligation d'État",
      CORP_BOND: "Obligation d'entreprise",
      REAL_ESTATE: "Immobilier",
      CRYPTO: "Crypto",
      CASH: "Liquidités",
      OTHER: "Autre",
      COPY_TRADE: "Copy trading",
    },
  },

  notFoundPage: {
    code: "404",
    message: "Oups ! Page introuvable.",
    returnHome: "Retour à l'accueil",
  },

  plaidConnect: {
    success: "Succès",
    bankReauthenticated: "La connexion bancaire a été ré-authentifiée avec succès.",
    reauthFailed: "La ré-authentification a réussi mais la mise à jour du statut a échoué.",
    exchangeFailed: "Échange échoué",
    connectFailed: "Échec de la connexion du compte bancaire.",
    reconnect: "Reconnecter",
    connectBank: "Connecter une banque",
  },

  accountSelection: {
    loadFailed: "Échec du chargement des comptes de la banque.",
    allAccountTypes: "Tous les types de compte",
    createNew: "Créer nouveau",
    createNewAccount: "Créer un nouveau compte",
    linkToExisting: "Lier à un existant",
    selectOrCreate: "Sélectionner ou créer",
    accountNames: "Noms des comptes",
    accountMappings: "Mappages de comptes",
    unsupportedCurrencies: "Devises non prises en charge",
    unsupportedCountry: "Pays non pris en charge",
    seedInterview: "Interview d'initialisation",
    allCategories: "Toutes les catégories",
    fetchFailed: "Échec de la récupération des comptes Plaid",
    setupTitle: "Configurer les Comptes",
    syncingTitle: "Synchronisation en Cours...",
    quickClassify: "Classification Rapide",
    syncComplete: "Synchronisation Terminée",
    setupDescription: "Choisissez les comptes à synchroniser, liez-les aux comptes existants et définissez les noms.",
    syncingDescription: "Vos transactions sont en cours de synchronisation et de classification par l'IA.",
    seedDescription: "Nous avons trouvé vos transactions les plus récurrentes. Confirmez ou ajustez leurs catégories pour rendre l'IA plus intelligente lors de votre prochaine synchronisation.",
    doneDescription: "Toutes les transactions ont été synchronisées et classifiées.",
    newCurrenciesDetected: "Nouvelles devises détectées",
    currenciesUse: "Ces comptes utilisent",
    currenciesNotConfigured: "qui {{plurality}} pas encore dans votre espace de travail. Elles seront ajoutées automatiquement lors de la synchronisation.",
    newCountryDetected: "Nouveau pays détecté",
    bankOperatesIn: "Cette banque opère en",
    countryNotConfigured: "qui n'est pas encore dans votre espace de travail. Il sera ajouté automatiquement lors de la synchronisation.",
    notConfigured: "non configuré",
    accountNamePlaceholder: "Nom du compte",
    existingAccountKept: "Le nom du compte existant sera conservé",
    noAccountsFound: "Aucun compte trouvé.",
    syncHistoryNote: "Bliss synchronisera jusqu'à 2 ans d'historique. Les transactions récentes apparaissent en secondes ; l'historique complet arrive sous 24 heures.",
    syncAccounts: "Synchroniser {{count}} Comptes",
    accountsLinked: "Comptes liés",
    syncingTransactions: "Synchronisation des transactions",
    aiClassifying: "Classification par l'IA",
    importingTransactions: "Importation de vos transactions récentes",
    importingFrom: "depuis",
    fullHistoryNote: "Votre historique complet de 2 ans continuera à se synchroniser en arrière-plan.",
    promoted: "Promues",
    pendingReview: "En Attente de Révision",
    processing: "En Traitement",
    doNotClose: "Veuillez ne pas fermer cette boîte de dialogue pendant la synchronisation.",
    skipForNow: "Passer pour le moment",
    confirmContinue: "Confirmer et Continuer",
    seedSaveFailed: "Impossible de sauvegarder les sélections de catégories.",
    historyRange: "Plage d'Historique",
    readyForReview: "Prêtes pour Révision",
    skippedDuplicates: "Ignorées (doublons)",
    fullHistorySyncing: "Historique complet en cours de synchronisation en arrière-plan",
    currentlySyncedFrom: "Actuellement synchronisé depuis",
    fullHistoryDetail: "Bliss synchronisera automatiquement jusqu'à 2 ans d'historique de transactions dans les prochaines 24 heures. Les nouvelles transactions apparaîtront dans votre file de révision au fur et à mesure — aucune action nécessaire.",
    reviewTransactions: "Réviser les Transactions",
    linkFailed: "Échec de la liaison des comptes.",
  },

  changePassword: {
    title: "Changer le mot de passe",
    description: "Entrez votre mot de passe actuel et choisissez-en un nouveau.",
    currentPassword: "Mot de passe actuel",
    currentPasswordRequired: "Le mot de passe actuel est requis",
    newPassword: "Nouveau mot de passe",
    newPasswordMin: "Le mot de passe doit comporter au moins 8 caractères",
    minHint: "Minimum 8 caractères",
    confirmPassword: "Confirmer le nouveau mot de passe",
    confirmRequired: "Veuillez confirmer votre nouveau mot de passe",
    mismatch: "Les mots de passe ne correspondent pas",
    updatePassword: "Mettre à jour le mot de passe",
    passwordUpdated: "Mot de passe mis à jour",
    passwordUpdatedDetail: "Votre mot de passe a été changé avec succès.",
    changeFailed: "Échec du changement de mot de passe",
  },

  transactionFormPage: {
    pickDate: "Choisir une date",
    descriptionPlaceholder: "ex. Courses, Salaire, Loyer",
    selectAccount: "Veuillez sélectionner un compte",
    selectCurrency: "Veuillez sélectionner une devise",
    selectCategory: "Veuillez sélectionner une catégorie",
    pricePerShare: "Prix par action",
    pricePlaceholder: "ex. 43.67",
    quantity: "Quantité",
    quantityAuto: "(auto)",
    quantityCalculated: "Calculé automatiquement",
    quantityPlaceholder: "ex. 1.23",
    detailsNotes: "Détails / Notes",
    notesPlaceholder: "Notes optionnelles (remplace la description par défaut)",
    debtTerms: "Conditions de dette",
    initialBalance: "Solde initial",
    interestRate: "Taux d'intérêt (%)",
    termMonths: "Durée (en mois)",
    originationDate: "Date d'origine",
    tags: "Tags",
    saving: "Enregistrement...",
    updatedSuccess: "Transaction mise à jour avec succès.",
    createdSuccess: "Transaction créée avec succès.",
    saveFailed: "Échec de l'enregistrement de la transaction. Veuillez réessayer.",
    currencyMismatch: "Cet actif est coté en {{currency}}. Veuillez sélectionner un compte en {{currency}}.",
    currencyMismatchAlt: "Veuillez sélectionner un compte en {{currency}} ou choisir un actif coté en {{txCurrency}}.",
    tickerRequired: "Le ticker est obligatoire pour cette catégorie.",
    priceRequired: "Le prix est obligatoire pour cette catégorie.",
    quantityRequired: "La quantité est obligatoire pour cette catégorie.",
    dateLabel: "Date",
    descriptionLabel: "Description",
    accountLabel: "Compte",
    creditLabel: "Crédit",
    debitLabel: "Débit",
    categoryLabel: "Catégorie",
    investmentDetails: "Détails de l'investissement",
    investmentDetailsHint: "(sélectionnez une catégorie d'investissement pour activer)",
    tickerLabel: "Ticker",
    tickerPlaceholder: "ex., AAPL, VWCE",
    etoroUsernameLabel: "Nom d'utilisateur eToro",
    etoroUsernamePlaceholder: "Investisseur copié, ex. topinvestor",
    copyTradeAmountHint: "Saisissez le montant versé dans la copie (ou retiré). Pas de prix ni de quantité : le montant est votre coût et eToro fournit la valeur.",
    loadingFormData: "Chargement des données du formulaire...",
    closePosition: "Clôturer la position complète",
    closePositionHint: "Définit la quantité à votre position exacte de {{quantity}} unités",
    closePositionActive: "Clôture de position active",
    lotMismatchWarning: "Écart de quantité de position",
    lotMismatchDetail: "Cette position affiche une quantité négative — il manque peut-être une transaction d'achat ou un transfert entre comptes non enregistré.",
  },

  debtTermsForm: {
    initialBalance: "Solde initial",
    initialBalanceError: "Le solde initial doit être un nombre positif.",
    interestRate: "Taux d'intérêt (%)",
    interestRateNegative: "Le taux d'intérêt ne peut pas être négatif.",
    interestRateTooHigh: "Le taux d'intérêt semble trop élevé.",
    termMonths: "Durée (en mois)",
    termError: "La durée doit être un nombre positif de mois.",
    originationDate: "Date d'origine",
    originationRequired: "Une date d'origine est requise.",
    pickDate: "Choisir une date",
    saveTerms: "Enregistrer les conditions",
    saving: "Enregistrement...",
    success: "Succès !",
    savedDetail: "Les conditions de dette de {{name}} ont été enregistrées.",
    saveFailed: "Échec de l'enregistrement des conditions. Veuillez réessayer.",
  },

  manualPriceForm: {
    date: "Date",
    pickDate: "Choisir une date",
    price: "Prix",
    pricePlaceholder: "ex. 150,50",
    currency: "Devise",
    currencyPlaceholder: "ex. USD",
    notes: "Notes (optionnel)",
    notesPlaceholder: "ex. Source de l'évaluation",
    savePrice: "Enregistrer le prix",
    saving: "Enregistrement...",
    success: "Succès !",
    savedDetail: "Le prix de {{name}} a été mis à jour.",
    saveFailed: "Échec de la mise à jour du prix. Veuillez réessayer.",
  },

  manualPriceHistory: {
    title: "Historique des prix — {{symbol}}",
    dialogDescription: "Consultez, modifiez ou supprimez les prix que vous avez saisis manuellement pour cet actif.",
    addTitle: "Enregistrer un prix — {{symbol}}",
    editTitle: "Modifier le prix — {{symbol}}",
    countLabel_one: "{{count}} mise à jour",
    countLabel_other: "{{count}} mises à jour",
    countLabel: "{{count}} mises à jour",
    effectiveDate: "Date d'effet",
    price: "Prix",
    currency: "Devise",
    notes: "Notes",
    recordedOn: "Enregistré le",
    actions: "Actions",
    edit: "Modifier",
    delete: "Supprimer",
    back: "Retour à l'historique",
    differentCurrency: "Cette entrée est enregistrée dans une devise différente de celle de l'actif.",
    emptyTitle: "Aucun prix manuel enregistré pour l'instant",
    emptyBody: "Enregistrez le premier prix de cet actif pour commencer à constituer son historique.",
    recordFirst: "Enregistrer le premier prix",
    recordPrice: "Enregistrer un prix",
    loadError: "Échec du chargement de l'historique des prix.",
    retry: "Réessayer",
    deleteConfirmTitle: "Supprimer cette entrée de prix ?",
    deleteConfirmBody: "Cette action supprime définitivement le prix enregistré et relance la valorisation du portefeuille. Elle est irréversible.",
    deleted: "Entrée de prix supprimée",
    deleteFailed: "Échec de la suppression de l'entrée de prix. Veuillez réessayer.",
    viewHistory: "Voir l'historique",
    lastUpdated: "Dernière mise à jour",
    allManualAssetsTitle: "Tous les actifs à prix manuel",
    allManualAssetsDesc: "Tous les actifs que vous valorisez à la main. Ouvrez leur historique pour consulter, modifier ou supprimer les entrées passées.",
    noManualAssets: "Aucun actif à prix manuel pour l'instant.",
    pagination: "Affichage de {{from}}–{{to}} sur {{total}}",
    prev: "Précédent",
    next: "Suivant",
  },

  categoryCombobox: {
    search: "Rechercher des catégories...",
    noResults: "Aucune catégorie trouvée.",
  },

  categoryFormPage: {
    nameMin: "Le nom doit comporter au moins 2 caractères",
    typeRequired: "Le type est obligatoire",
    groupRequired: "Le groupe est obligatoire",
    iconLabel: "Icône",
    iconHint: "Collez un emoji pour l'utiliser comme icône de catégorie.",
    recurringLabel: "Frais récurrent",
    recurringHint: "Afficher les transactions de cette catégorie dans la vue Abonnements. Un seul prélèvement suffit à l'y faire figurer.",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Expliquez brièvement quand utiliser cette catégorie…",
    descriptionHint: "Affichée en infobulle dans le sélecteur de catégories. Vous aide (ou les autres utilisateurs de votre compte) à choisir la bonne catégorie.",
    namePlaceholder: "ex. Courses, Salaire, Loyer",
    selectType: "Sélectionner le type",
    selectGroup: "Sélectionner le groupe",
    selectTypeFirst: "Sélectionnez d'abord un type",
    createNewGroup: "+ Créer un nouveau groupe\u2026",
    enterNewGroup: "Entrez le nom du nouveau groupe",
    iconOptional: "(facultatif)",
  },

  categoriesPage: {
    defaultBadge: "Par défaut",
    systemHint: "Catégorie système — utilisée pour la classification IA sur tous les tenants. Ne peut pas être supprimée.",
    transaction: "transaction",
    transactions: "transactions",
    categoryOptions: "Options de catégorie",
    rename: "Renommer",
    addTo: "Ajouter à {{type}}",
    reassignAndDelete: "Réassigner et supprimer",
    reassignMessage: "\"{{name}}\" a {{count}} transaction(s). Choisissez une catégorie pour les réassigner avant de supprimer.",
    selectTargetCategory: "Sélectionner la catégorie cible",
    deleteAndReassign: "Supprimer et réassigner",
    deletedAndReassigned: "{{name}} supprimée et {{count}} transaction(s) réassignées",
  },

  expenseSplit: {
    title: "Répartition des dépenses",
    thisYear: "Cette année",
    thisMonth: "Ce mois",
    lastMonth: "Mois dernier",
    last3Months: "3 derniers mois",
    noData: "Aucune donnée de dépense pour cette période.",
    viewExpenses: "Voir les dépenses",
    ofSpending: "des dépenses",
    basis: "Débits − crédits",
    netCredits: "Crédits nets",
    noNetSpend: "Aucune dépense nette sur cette période",
  },

  // Smart Import page
  smartImport: {
    title: "Importation intelligente",
    subtitle: "Importez un fichier CSV ou Excel, laissez l'IA classer vos transactions, puis vérifiez et validez.",
    cancelImport: "Annuler l'importation",
    steps: {
      upload: "Importer",
      processing: "Traitement",
      review: "Vérifier",
      done: "Terminé",
    },
    status: {
      confirmed: "Confirmé",
      pending: "En attente",
      duplicate: "Doublon",
      possibleDup: "Doublon possible",
      skipped: "Ignoré",
      error: "Erreur",
    },
    source: {
      manual: "Manuel",
      exact: "Exact",
      vector: "Vecteur",
      ai: "IA",
    },
    selectFile: "Sélectionner un fichier",
    selectFileDesc: "Choisissez un relevé bancaire ou un fichier d'export (CSV ou Excel) à importer.",
    dropzone: "Cliquez pour sélectionner ou glissez un fichier CSV ou Excel",
    detectingFormat: "Détection du format du fichier...",
    formatDetected: "Format détecté : {{name}}",
    formatDetectedDesc: "Ce fichier correspond à l'adaptateur {{name}}. Le mappage des colonnes sera appliqué automatiquement.",
    unknownFormat: "Format inconnu",
    unknownFormatDesc: "Aucun adaptateur ne correspond à ce fichier. En-têtes détectés :",
    unknownFormatHeaderHint: "Bliss lit les en-têtes de colonnes sur la première ligne du fichier (ou de la feuille, pour Excel). Si votre fichier contient des lignes au-dessus des en-têtes — nom du compte, période, solde —, supprimez-les et importez-le à nouveau.",
    createAdapterForFormat: "Créer un adaptateur pour ce format",
    destinationAccount: "Compte de destination",
    destinationAccountDesc: "Toutes les transactions seront importées dans ce compte.",
    destinationAccountNative: "Optionnel — l'adaptateur natif résout le compte par ligne depuis votre CSV.",
    selectAccount: "Sélectionner un compte...",
    optionalFromCsv: "Optionnel — résolu depuis le CSV...",
    nativeAccountHint: "La colonne compte de chaque ligne remplace cette sélection. Sélectionnez un compte par défaut ici uniquement si certaines lignes n'ont pas de compte spécifié.",
    uploading: "Import en cours...",
    uploadAndProcess: "Importer et traiter",
    importAdapters: "Adaptateurs d'importation",
    hide: "Masquer",
    manage: "Gérer",
    noAdapters: "Aucun adaptateur. Créez-en un pour commencer à importer.",
    newAdapter: "Nouvel adaptateur",
    system: "Système",
    template: "Modèle",
    editAdapter: "Modifier l'adaptateur",
    createAdapter: "Créer un adaptateur",
    adapterFormDesc: "Définissez comment les colonnes CSV/Excel de votre banque correspondent aux champs de transaction Bliss.",
    form: {
      name: "Nom",
      nameRequired: "Le nom de l'adaptateur est obligatoire",
      namePlaceholder: "CSV Compte Chase",
      matchHeaders: "En-têtes de correspondance",
      matchHeadersPlaceholder: "Date, Description, Montant",
      matchHeadersHint: "En-têtes de colonnes qui identifient de manière unique le format d'export de votre banque.",
      matchHeadersChipsHint: "Sélectionnez les en-têtes de votre fichier qui identifient ce format. Ajoutez-en un personnalisé si besoin.",
      addCustomHeader: "Ajouter un en-tête personnalisé",
      dateColumn: "Colonne date",
      dateColumnPlaceholder: "Date",
      descriptionColumn: "Colonne description",
      descriptionColumnPlaceholder: "Description",
      amountStrategy: "Disposition du montant",
      singleSigned: "Une colonne, signée (la plupart des banques)",
      singleSignedDesc: "Ex. -45.20 = dépense, 25.00 = revenu",
      singleSignedInverted: "Une colonne, signes inversés (ex. Amex)",
      singleSignedInvertedDesc: "Ex. 45.20 = dépense, -25.00 = remboursement",
      debitCredit: "Colonnes débit et crédit séparées",
      debitCreditDesc: "Deux colonnes séparées pour les débits et crédits",
      amountWithType: "Montant + colonne de type",
      amountWithTypeDesc: "Une colonne montant et une colonne indiquant la direction",
      typeColumn: "Colonne type",
      typeColumnPlaceholder: "Type",
      categoryColumn: "Colonne catégorie (optionnel)",
      categoryColumnPlaceholder: "Aucune — ignorer la suggestion de catégorie",
      categoryColumnHint: "Si votre fichier contient une colonne catégorie, la mapper améliore la précision de l'IA",
      debitColumn: "Colonne débit",
      debitColumnPlaceholder: "Débit",
      creditColumn: "Colonne crédit",
      creditColumnPlaceholder: "Crédit",
      amountColumn: "Colonne montant",
      amountColumnPlaceholder: "Montant",
      customColumn: "Colonne personnalisée…",
      dateFormat: "Format de date",
      dateFormatAuto: "Détection automatique (recommandé)",
      dateFormatCustom: "Format personnalisé…",
      dateFormatGroupDate: "Date uniquement",
      dateFormatGroupDateTime: "Date + Heure",
      dateFormatAmbiguousWarning: "Format de date ambigu (toutes les valeurs ≤ 12). Sélectionnez un format explicite pour éviter les erreurs MM/JJ vs JJ/MM.",
      dateFormatHint: "Choisissez un format ou sélectionnez Personnalisé",
      defaultCurrency: "Devise par défaut",
      currencyHint: "Laissez vide si votre CSV contient une colonne devise par ligne",
      currencyNone: "Aucune — utiliser la colonne devise par ligne",
      skipRows: "Lignes à ignorer (lignes d'en-tête)",
      previewTitle: "Aperçu ligne 1",
      previewHint: "Remplissez les colonnes ci-dessus pour voir comment la ligne 1 sera interprétée",
      previewNoData: "Importez d'abord un fichier pour activer l'aperçu",
      previewDate: "Date",
      previewDescription: "Description",
      previewAmount: "Montant",
      previewCurrency: "Devise",
      previewBankCategory: "Catégorie bancaire",
    },
    unknownFormatSamplePreview: "Exemples de lignes de votre fichier :",
    processingTitle: "Traitement de votre importation",
    processingDesc: "L'IA classe vos transactions. Cela peut prendre un moment...",
    percentComplete: "{{pct}}% terminé",
    unknownAccount: "Compte inconnu",
    quickClassify: "Classification rapide",
    quickClassifyDesc: "Nous avons trouvé vos transactions les plus récurrentes. Confirmez ou ajustez leurs catégories pour améliorer l'IA lors des prochaines importations.",
    skipForNow: "Ignorer pour le moment",
    confirmAndContinue: "Confirmer et continuer",
    confirmAll: "Tout confirmer",
    seed: {
      global: "Global",
      match: "Correspondance",
      restore: "Restaurer",
      skipMerchant: "Ignorer ce commerçant",
    },
    review: {
      file: "Fichier",
      account: "Compte",
      total: "Total",
      nRows: "{{count}} lignes",
      earliest: "La plus ancienne",
      autoConfirmed: "{{count}} auto-confirmées",
      nUpdates: "{{count}} mises à jour",
      pendingReview: "{{count}} en attente de vérification",
      nDuplicates: "{{count}} doublons",
      nErrors: "{{count}} erreurs",
      filterByStatus: "Filtrer par statut",
      flat: "Plat",
      grouped: "Groupé",
      errorLoadingTitle: "Erreur de chargement de l'importation",
      errorLoadingDesc: "Impossible de charger les données d'importation. Veuillez actualiser la page.",
      noRowsFound: "Aucune ligne trouvée",
      tryDifferentFilter: "Essayez un filtre différent.",
      noRowsProduced: "L'importation n'a produit aucune ligne.",
      pageOf: "Page {{current}} de {{total}}",
    },
    filter: {
      allRows: "Toutes les lignes",
      possibleDuplicate: "Doublon possible",
    },
    committingTitle: "Validation des transactions",
    committingDesc: "Création des transactions à partir de vos lignes confirmées...",
    committing: "Validation...",
    commitImport: "Valider les confirmées",
    importError: "Erreur d'importation",
    processingError: "Une erreur est survenue lors du traitement.",
    processingFailed: "Traitement échoué",
    startOver: "Recommencer",
    importComplete: "Importation terminée !",
    importCompleteDesc: "Vos transactions ont été validées avec succès.",
    done: {
      created: "Créées",
      updated: "Mises à jour",
      remaining: "Restantes",
    },
    importAnotherFile: "Importer un autre fichier",
    reviewInTransactionReview: "Vérifier dans la révision des transactions",
    commitDialogDesc: "Cela créera des transactions uniquement pour les lignes confirmées. Les lignes en attente resteront disponibles pour une révision ultérieure. Cette action est irréversible.",
    goBack: "Retour",
    yesCommit: "Oui, valider",
    cancelDialogDesc: "Êtes-vous sûr de vouloir annuler ? Toutes les lignes préparées seront supprimées.",
    cancelling: "Annulation...",
    yesCancelImport: "Oui, annuler l'importation",
    toast: {
      importReady: "Importation prête",
      rowsReady: "{{count}} lignes prêtes pour vérification.",
      seedSaveFailed: "Impossible d'enregistrer les sélections de catégories.",
      detectionFailed: "Détection échouée",
      detectionFailedDesc: "Impossible de détecter le format du fichier. Vérifiez votre fichier CSV ou Excel.",
      uploadFailed: "Import échoué",
      uploadFailedDesc: "Impossible de démarrer l'importation. Veuillez réessayer.",
      otherTransactions: "{{count}} autres transactions dans \"{{category}}\"",
      confirmAllQuestion: "Tout confirmer ?",
      confirmedN: "{{count}} transactions confirmées",
      commitStarted: "Validation démarrée",
      commitStartedDesc: "Vos transactions sont en cours de validation...",
      commitFailed: "Validation échouée",
      commitFailedDesc: "Impossible de démarrer le processus de validation.",
      importCancelled: "Importation annulée",
      cancelFailed: "Annulation échouée",
      adapterUpdated: "Adaptateur mis à jour",
      adapterCreated: "Adaptateur créé",
      adapterDeleted: "Adaptateur supprimé",
      formatMatched: "Format reconnu : {{name}}",
      formatMatchedDesc: "Votre fichier est maintenant reconnu. Vous pouvez procéder à l'import.",
      updateFailed: "Mise à jour échouée",
      createFailed: "Création échouée",
      deleteFailed: "Suppression échouée",
    },
  },

  // Insights page
  insights: {
    title: "Analyses",
    subtitle: "Observations financières alimentées par l'IA",
    v1Subtitle: "Intelligence financière alimentée par l'IA : bilans mensuels, tendances trimestrielles, récapitulatifs annuels et analyse de portefeuille",
    lastUpdated: "Dernière mise à jour",
    generating: "Génération...",
    generateNew: "Générer de nouvelles analyses",
    generate: "Générer des analyses",
    generateAll: "Générer tous les niveaux",
    refresh: "Actualiser",
    refreshTier: "Régénérer",
    moreActions: "Plus d'actions",
    reload: "Recharger",
    clearFilters: "Effacer les filtres",
    noInsightsYet: "Aucune analyse pour le moment",
    noInsightsDesc: "Une fois que vous aurez des données de transactions, Bliss analysera vos finances et mettra en évidence les tendances importantes.",
    noCategoryInsights: "Aucune analyse ne correspond aux catégories sélectionnées pour cette période.",
    noTierInsightsDesc: "Aucune analyse n'a encore été générée pour ce niveau. Utilisez Régénérer pour en créer une pour la période la plus récente.",
    period: {
      selectPlaceholder: "Sélectionner la période",
      q: "T",
    },
    severity: {
      POSITIVE: "Positif",
      INFO: "Info",
      WARNING: "Avertissement",
      CRITICAL: "Critique",
    },
    categories: {
      all: "Tout",
      spending: "Dépenses",
      income: "Revenus",
      savings: "Épargne",
      portfolio: "Portefeuille",
      debt: "Dettes",
      netWorth: "Patrimoine net",
    },
    tiers: {
      monthly: "Bilan mensuel",
      quarterly: "Analyse trimestrielle",
      annual: "Rapport annuel",
      portfolio: "Intelligence portefeuille",
    },
    lens: {
      passiveIncomeOutlook: "Perspectives de revenus passifs",
    },
    actions: {
      passiveIncomeSetup: "Configurer les conditions de revenus",
      portfolioHoldings: "Portefeuille",
    },
  },

  // Manual Updates page
  manualUpdates: {
    pageTitle: "Mises à jour manuelles et conditions",
    pageSubtitle: "Gardez vos actifs manuels et passifs à jour.",
    errorLoading: "Échec du chargement des données d'actifs. Veuillez réessayer.",
    stalePricesTitle: "Action requise : Prix obsolètes",
    stalePricesDesc: "Ces actifs suivis manuellement n'ont pas été mis à jour depuis plus de 30 jours.",
    asset: "Actif",
    value: "Valeur",
    status: "Statut",
    action: "Action",
    never: "Jamais",
    updatedOn: "Mis à jour {{date}}",
    dOld: "{{count}}j ancien",
    updatePrice: "Mettre à jour le prix",
    allUpToDate: "Tous les actifs suivis manuellement sont à jour.",
    liabilityTerms: "Conditions des passifs",
    liabilityTermsDesc: "Gérez les conditions de vos prêts et lignes de crédit suivis manuellement.",
    debtName: "Nom de la dette",
    principalBalance: "Solde principal",
    interestRate: "Taux d'intérêt",
    duration: "Durée",
    yr: "an",
    mo: "mois",
    editTerms: "Modifier les conditions",
    addTerms: "Ajouter des conditions",
    totalOutstanding: "Total en cours",
    noLiabilities: "Aucun passif trouvé.",
    updatePriceDialog: "Mettre à jour le prix",
    debtTermsDialog: "Conditions de la dette",
    urgency: {
      critical: "Critique",
      warning: "Attention",
      stale: "Obsolète",
    },
  },

  spendingChart: {
    title: "Dépenses par catégorie",
    selectPeriod: "Sélectionner la période",
    thisMonth: "Ce mois",
    lastMonth: "Mois dernier",
    last3Months: "3 derniers mois",
    noData: "Aucune donnée de dépense pour cette période.",
  },

  // Portfolio holdings page
  portfolio: {
    title: "Portefeuille",
    subtitle: "Suivez la performance et la composition de votre portefeuille d'investissements",
    assets: "Actifs",
    liabilities: "Passifs",
    positionCount_one: "{{count}} position",
    positionCount_other: "{{count}} positions",
    positionCount: "{{count}} positions",
    symbol: "Symbole",
    qty: "Qté",
    price: "Prix",
    costBasis: "Prix de revient",
    unrealizedPnL: "P&L latent",
    realizedPnL: "P&L réalisé",
    roiPercent: "ROI %",
    totalValue: "Valeur totale",
    roiTooltip: "ROI total = (P&L réalisé + latent) / Total investi",
    showDebt: "Afficher la dette",
    allAccounts: "Tous les comptes",
    allCountries: "Tous les pays",
    noHistoricalData: "Aucune donnée historique disponible pour cette période.",
    // Holding filter (#131)
    allHoldings: "Toutes les positions",
    searchHoldings: "Rechercher une position…",
    noHoldingsFound: "Aucune position trouvée.",
    showClosedPositionsToggle: "Afficher les positions clôturées",
    closedBadge: "Clôturée",
    closedPositionsGroup: "Positions clôturées",
    clearHolding: "Effacer le filtre de position",
    showInChart: "Afficher dans le graphique",
    holdingNotInAccount: "{{symbol}} n'est pas détenu dans {{account}}",
    noHistoryForHolding: "Aucun historique pour {{name}} sur cette période",
    holdingPickerLabel: "Filtrer le graphique par position",
    netWorth: "Patrimoine net",
    emptyState: "Aucune donnée de portefeuille. Connectez un compte bancaire ou importez des transactions pour commencer.",
    connectAccount: "Connecter un compte",
    importCSV: "Importer CSV",
    errorTitle: "Erreur de chargement du portefeuille",
    errorDescription: "Un problème est survenu lors du chargement de vos données de portefeuille. Veuillez réessayer plus tard.",
    liability: "Passif",
    interestRate: "Taux d'intérêt",
    term: "Durée",
    balance: "Solde",
    totalOutstanding: "Total en cours",
    editTerms: "Modifier les conditions",
    addTerms: "Ajouter des conditions",
    hideClosedPositions_one: "Masquer {{count}} position clôturée",
    hideClosedPositions_other: "Masquer {{count}} positions clôturées",
    hideClosedPositions: "Masquer {{count}} positions clôturées",
    showClosedPositions_one: "Afficher {{count}} position clôturée",
    showClosedPositions_other: "Afficher {{count}} positions clôturées",
    showClosedPositions: "Afficher {{count}} positions clôturées",
  },

  // Tag analytics page
  tagAnalytics: {
    title: "Analyse par tags",
    subtitle: "Analysez les dépenses par tag sur tous les comptes et devises",
    selectTag: "Sélectionnez un tag...",
    compare: "Comparer",
    compareWith: "Comparer avec...",
    searchTags: "Rechercher des tags...",
    noTagsFound: "Aucun tag trouvé.",
    emptyTitle: "Sélectionnez un tag pour voir l'analyse",
    emptyDescription: "Choisissez un tag ci-dessus pour voir les ventilations de dépenses, tendances et suivi de budget",
    totalDebit: "Total débit",
    totalCredit: "Total crédit",
    balance: "Solde",
    budgetProgress: "Progression du budget",
    topCategory: "Catégorie principale",
    categoryBreakdown: "Ventilation par catégorie",
    noSpendingData: "Aucune donnée de dépense pour ce tag",
    cashFlowTimeline: "Chronologie des flux de trésorerie",
    noTimelineData: "Aucune donnée de chronologie",
    monthly: "Mensuel",
  },

  // Auth page — flat string keys
  "Sign In": "Se connecter",
  "Sign Up": "S'inscrire",
  "Sign in with Google": "Se connecter avec Google",

  // Auth rejection messages (task #71 — identity hygiene)
  "An account with this email already exists. Sign in with your password instead.": "Un compte existe déjà avec cette adresse e-mail. Connectez-vous avec votre mot de passe.",
  "Your Google account's email address is not verified. Verify it with Google, then try again.": "L'adresse e-mail de votre compte Google n'est pas vérifiée. Vérifiez-la auprès de Google, puis réessayez.",
  "Sign-in with Google failed. Please try again.": "La connexion avec Google a échoué. Veuillez réessayer.",
  "We could not sign you in automatically. Please try signing in with your password.": "Nous n'avons pas pu vous connecter automatiquement. Essayez de vous connecter avec votre mot de passe.",

  // Invite-only sign-up (task #99)
  "This Bliss instance is invite-only. Use the email address you were invited with.": "Cette instance de Bliss est sur invitation uniquement. Utilisez l'adresse e-mail avec laquelle vous avez été invité.",
  "This email hasn't been invited to this Bliss instance. Ask the person who runs it for an invite.": "Cette adresse e-mail n'a pas été invitée sur cette instance de Bliss. Demandez une invitation à la personne qui la gère.",
  "Sign up with Google": "S'inscrire avec Google",
  "or continue with email": "ou continuer avec l'e-mail",
  "Email address": "Adresse e-mail",
  "Password": "Mot de passe",
  "Signing in...": "Connexion en cours...",
  "Login failed": "Échec de la connexion",
  "Full name": "Nom complet",
  "Use at least 8 characters, including a number.": "Utilisez au moins 8 caractères, dont un chiffre.",
  "By creating an account you agree to our": "En créant un compte, vous acceptez nos",
  "and": "et",
  "Registration failed": "Échec de l'inscription",
  "Creating account...": "Création du compte...",
  "Create Account": "Créer un compte",
  "Don't have an account?": "Vous n'avez pas de compte ?",
  "Create one": "Créez-en un",
  "Already have an account?": "Vous avez déjà un compte ?",
  "Sign in": "Se connecter",
  "Welcome to the Bliss demo. Use the credentials below to sign in and explore.": "Bienvenue dans la démo Bliss. Utilisez les identifiants ci-dessous pour vous connecter et explorer.",
  "The quiet intelligence behind your global wealth.": "L'intelligence discrète derrière votre patrimoine mondial.",
  "Financial clarity, without borders.": "Clarté financière, sans frontières.",
  "Bliss capybara in a turtleneck, seated in a mid-century chair beside a stack of currency coins": "Capybara Bliss en col roulé, assis dans un fauteuil mid-century à côté de pièces de monnaie",
  "Bliss capybara mascot seated in a mid-century chair": "Mascotte capybara Bliss assise dans un fauteuil mid-century",
  "Welcome back": "Bon retour",
  "Protected by enterprise-grade encryption.": "Protégé par un chiffrement de niveau entreprise.",

  // Dashboard actions — flat string keys
  "Fix Bank Connection": "Réparer la connexion bancaire",
  "A bank connection needs your attention": "Une connexion bancaire nécessite votre attention",
  "Review Pending Transactions": "Examiner les transactions en attente",
  "Check and categorize imported transactions": "Vérifiez et catégorisez les transactions importées",
  "Update Asset Prices": "Mettre à jour les prix des actifs",
  "Some manual assets need a price refresh": "Certains actifs manuels ont besoin d'une mise à jour de prix",
  "Connect your bank": "Connectez votre banque",
  "Plaid (US, CA, UK) or Enable Banking (EU) for automatic sync": "Plaid (É.-U., CA, R.-U.) ou Enable Banking (UE) pour une synchronisation automatique",
  "Add Manual Account": "Ajouter un compte manuel",
  "Manually track an account or asset": "Suivez manuellement un compte ou un actif",
  "Import Transactions": "Importer des transactions",
  "Upload a CSV file to import transactions": "Téléchargez un fichier CSV pour importer des transactions",
  "View Insights": "Voir les analyses",
  "See AI-generated financial observations": "Voir les observations financières générées par l'IA",
  "Explore Expenses": "Explorer les dépenses",
  "See how your spending breaks down": "Voyez comment vos dépenses se répartissent",
  "View Financial Summary": "Voir le Résumé Financier",
  "View income vs expenses over time": "Voir les revenus vs dépenses dans le temps",
  "View Accounts": "Voir les comptes",
  "See all your connected accounts": "Voir tous vos comptes connectés",

  // Setup checklist — flat string keys
  "Get started with Bliss": "Commencer avec Bliss",
  "of": "sur",
  "complete": "terminé",
  "Dismiss": "Ignorer",
  // ─── Subscriptions / recurring charges ───────────────────────────────────────
  subscriptions: {
    title: "Abonnements",
    subtitle: "Prélèvements récurrents détectés sur vos comptes.",
    scanNow: "Analyser",
    scanCooldownShort: "Analyse dans {{count}} min",
    scanStarted: "Analyse lancée",
    scanStartedHint: "La détection s'exécute en arrière-plan. Les résultats arrivent bientôt.",
    scanCooldown: "Analyse en pause",
    scanCooldownHint: "Vous pourrez relancer une analyse dans environ {{count}} minutes.",
    actionFailed: "L'action a échoué",
    fullScanHintPrefix: "D'anciens abonnements annuels peuvent manquer —",
    fullScanHintLink: "lancez une analyse complète de l'historique",
    fullScanHintSuffix: " dans Paramètres → Maintenance.",
    loadError: "Impossible de charger les abonnements.",
    uncategorized: "Sans catégorie",
    toggleCharges: "Afficher les prélèvements",
    noCharges: "Aucun prélèvement trouvé pour ce marchand.",
    fxUnavailable: "Taux indisponible",
    occurrences_one: "{{count}} prélèvement",
    occurrences_other: "{{count}} prélèvements",
    confirm: "Confirmer",
    confirmed: "Marqué comme abonnement",
    notASubscription: "Pas un abonnement",
    dismissed: "Retiré des abonnements",
    remove: "Retirer",
    removed: "Retiré",
    restore: "Restaurer",
    restored: "Restauré",
    summary: {
      monthly: "Mensuel",
      annual: "Annualisé",
      count: "Abonnements actifs",
      fxExcluded: "{{count}} exclus (pas de taux de change)",
    },
    filter: {
      active: "Actifs",
      lapsed: "Expirés",
      all: "Tous",
      allCategories: "Toutes les catégories",
    },
    empty: {
      title: "Aucun prélèvement récurrent pour le moment",
      body: "Dès qu'un marchand vous prélève plusieurs fois, il apparaîtra ici.",
    },
    status: {
      active: "Actif",
      lapsed: "Expiré",
    },
    cadence: {
      WEEKLY: "Hebdomadaire",
      MONTHLY: "Mensuel",
      QUARTERLY: "Trimestriel",
      ANNUAL: "Annuel",
      unknown: "Inconnue",
    },
    due: {
      today: "échéance aujourd'hui",
      inDays: "échéance dans {{count}} j",
      agoDays: "en retard de {{count}} j",
    },
    rename: {
      label: "Renommer l'abonnement",
      renamed: "Abonnement renommé",
      custom: "nom personnalisé",
    },
    merge: {
      mergeInto: "Fusionner avec un autre abonnement",
      pickTarget: "Choisir un abonnement…",
      merged: "Abonnements fusionnés",
      unmerge: "Annuler la fusion",
      unmerged: "Fusion annulée",
      tombstoneHint: "Intégré à un autre abonnement — ses frais sont comptés pour celui-ci.",
      unknownTarget: "un autre abonnement",
      mergedCountHint_one: "{{count}} fusionné avec un autre — gérer",
      mergedCountHint_other: "{{count}} fusionnés avec d'autres — gérer",
      targetMissing: "Cible de fusion introuvable",
      stale: "Cette fusion ne prend pas effet — annulez-la puis fusionnez à nouveau.",
      dismissBlocked: "Annulez d'abord la fusion des lignes intégrées à celle-ci.",
    },
    split: {
      splitByAmount: "Séparer par montant — un abonnement par prix",
      split: "Séparé en un abonnement par montant",
      unsplit: "Annuler la séparation",
      unsplitDone: "Séparation annulée",
      markerHint: "Séparé par montant — chaque prix récurrent est un abonnement distinct.",
      nothingToSplit: "Ces prélèvements ne se répètent pas à deux montants différents ou plus.",
    },
    pager: {
      prev: "Précédent",
      next: "Suivant",
      pageOf: "Page {{page}} sur {{total}}",
    },
  },

  // Passive Income (#77)
  passiveIncome: {
    title: "Revenus passifs",
    subtitle: "Dividendes, coupons, loyers, intérêts et prestations prévus à côté de ce que vous avez réellement reçu",
    loadFailed: "Impossible de charger les revenus passifs.",
    horizon: "Horizon de projection",
    months_one: "{{count}} mois",
    months_other: "{{count}} mois",
    kpi: {
      next12m: "12 prochains mois",
      split: "{{investment}} placements · {{other}} autres",
      monthlyAverage: "Moyenne mensuelle",
      yieldOnValue: "Rendement sur valeur",
      yieldHint: "Revenus de placement uniquement",
      essentialsCoverage: "Dépenses essentielles couvertes",
      essentialsHint: "sur {{amount}} dépensés ces 12 derniers mois",
      noEssentials: "Aucune dépense essentielle enregistrée",
      dataCoverage: "Couverture des données",
      dataCoverageValue: "{{configured}} sur {{total}}",
      dataCoverageHint: "positions génératrices de revenus configurées",
    },
    chart: {
      title: "Revenus réels vs prévus",
      actual: "Réel",
      today: "Aujourd'hui",
    },
    bucket: {
      dividend: "Dividendes",
      coupon: "Coupons",
      rent: "Loyers",
      interest: "Intérêts",
      other: "Allocations et prestations",
    },
    frequency: {
      WEEKLY: "Hebdomadaire",
      MONTHLY: "Mensuel",
      QUARTERLY: "Trimestriel",
      SEMIANNUAL: "Semestriel",
      ANNUAL: "Annuel",
      AT_MATURITY: "À l'échéance",
      IRREGULAR: "Irrégulier",
      MIXED: "Mixte",
      NONE: "Aucun paiement",
    },
    incomeType: {
      DIVIDEND: "Dividende",
      FIXED_COUPON: "Obligation à taux fixe",
      FLOATING_COUPON: "Obligation à taux variable",
      INFLATION_LINKED: "Obligation indexée sur l'inflation",
      RENT: "Loyer",
      INTEREST: "Intérêts",
      CUSTOM_YIELD: "Rendement",
      FIXED_AMOUNT: "Montant fixe",
      NONE: "Aucun revenu",
    },
    source: {
      AUTO: "Auto",
      OVERRIDE: "Personnalisé",
      MANUAL: "Manuel",
      MISSING: "Manquant",
      MIXED: "Mixte",
    },
    status: {
      OK: "OK",
      MATURED_UNREDEEMED: "Échu : enregistrez le remboursement",
      ENDED: "Terminé",
      STALE_RATE: "Le taux est peut-être obsolète",
    },
    yearly: {
      title: "Résumé annuel",
      source: "Source",
      year: "Année {{n}}",
      total: "Total",
    },
    upcoming: {
      title: "Paiements à venir",
      empty: "Aucun paiement prévu pour l'instant.",
    },
    breakdown: {
      filters: {
        all: "Tout",
        assets: "Positions",
        streams: "Flux",
        attention: "À vérifier",
      },
      search: "Rechercher positions ou flux",
      filter: "Filtrer",
      noMatches: "Aucun résultat pour cette recherche.",
      showing: "{{from}}–{{to}} sur {{total}}",
      prev: "Page précédente",
      next: "Page suivante",
      title: "Détail par position ou flux",
      description: "Prévu sur les {{count}} prochains mois",
      empty: "Aucun revenu configuré. Ajoutez des conditions de revenus à vos positions ou un flux de revenus.",
      holding: "Position / flux",
      type: "Type",
      rateOrAmount: "Taux / montant",
      frequency: "Fréquence",
      nextPayment: "Prochain paiement",
      endDate: "Fin",
      horizonTotal: "Prévu",
      mixed: "Mixte",
      accounts_one: "{{count}} compte",
      accounts_other: "{{count}} comptes",
      showAccounts_one: "Afficher {{count}} compte",
      showAccounts_other: "Afficher {{count}} comptes",
      hideAccounts: "Masquer les comptes",
      editGroup: "Modifier les conditions de revenus de toutes les positions {{name}}",
      cashSummary: "Solde {{balance}} · {{monthly}}/mois",
      quantity: "{{value}} unités",
      view: {
        label: "Vue de la répartition",
        grouped: "Par actif",
        flat: "Par compte",
      },
    },
    ladder: {
      title: "Échelonnement des échéances",
      description: "Capital remboursé par an (non compté comme revenu)",
      empty: "Aucune obligation n'arrive à échéance sur cet horizon.",
    },
    streams: {
      title: "Autres flux de revenus",
      description: "Allocations et prestations publiques non liées à un actif",
      add: "Ajouter un flux",
      empty: "Aucun flux de revenus pour l'instant.",
      noCategories: "Créez une catégorie Allocation ou Aides publiques dans le groupe Revenus passifs pour ajouter des flux.",
    },
    missing: {
      showAll: "Tout afficher ({{count}})",
      showLess: "Afficher moins",
      title_one: "{{count}} position n'a pas de données de revenus",
      title_other: "{{count}} positions n'ont pas de données de revenus",
      description: "Ajoutez leurs conditions de revenus ou indiquez qu'elles ne distribuent pas pour compléter la projection.",
    },
    detached: {
      searchAsset: "Rechercher des positions…",
      noAssets: "Aucune position sans conditions de revenus.",
      title: "Conditions de revenus détachées",
      description: "Ces conditions appartenaient à des positions recréées après une importation corrigée. Rattachez-les à la bonne position ou supprimez-les.",
      unnamed: "Position sans nom",
      detachedOn: "détaché le {{date}}",
      reattach: "Rattacher",
      discard: "Supprimer",
      pickAsset: "Choisissez une position",
      confirmAttach: "Rattacher",
      attached: "Conditions de revenus rattachées",
      attachFailed: "Impossible de rattacher les conditions de revenus.",
      discardTitle: "Supprimer ces conditions de revenus ?",
      discardConfirm: "Elles seront supprimées définitivement.",
      discarded: "Conditions de revenus supprimées",
      discardFailed: "Impossible de supprimer les conditions de revenus.",
    },
  },
  incomeTerms: {
    faceValueHint_one: "{{units}} unité détenue · {{perUnit}} par unité",
    faceValueHint_other: "{{units}} unités détenues · {{perUnit}} par unité",
    pickDate: "Choisir une date",
    clearDate: "Effacer la date",
    action: "Conditions de revenus",
    actionConfigured: "Conditions de revenus (configurées)",
    title: "Conditions de revenus — {{name}}",
    addStreamTitle: "Ajouter un flux de revenus",
    editStreamTitle: "Modifier le flux de revenus",
    assetDescription: "Indiquez à Bliss ce que rapporte cette position pour projeter vos revenus passifs. Montants bruts.",
    streamDescription: "Un revenu récurrent non lié à un actif, comme une allocation ou une pension publique.",
    notIncomeCapable: "Cette position ne peut pas générer de revenus passifs.",
    autoTitle: "Données de dividendes automatiques",
    autoSummary: "{{count}} paiements ces 12 derniers mois ({{frequency}}) · {{amount}} par action · dernier détachement {{date}}",
    autoNone: "Aucun dividende ces 12 derniers mois (par ex. un fonds de capitalisation). La projection est nulle et n'est pas signalée comme manquante.",
    autoUnavailable: "Pas encore de données de dividendes fiables. Ajoutez une valeur personnalisée ci-dessous.",
    override: "Remplacer les dividendes automatiques",
    notDistributing: "Ne distribue pas de revenus",
    groupTitle_one: "Conditions de revenus — {{name}} ({{count}} compte)",
    groupTitle_other: "Conditions de revenus — {{name}} ({{count}} comptes)",
    applyToAllHoldings_one: "Appliquer à toutes les positions {{symbol}} ({{count}})",
    applyToAllHoldings_other: "Appliquer aux {{count}} positions {{symbol}}",
    appliesToHoldings_one: "S'applique à {{count}} position {{symbol}}",
    appliesToHoldings_other: "S'applique aux {{count}} positions {{symbol}}",
    mixedTitle: "Ces positions n'ont pas les mêmes conditions",
    mixedDescription: "Chaque compte de {{symbol}} a actuellement ses propres données de revenu. Choisissez un compte comme point de départ.",
    mixedAccount: "Compte",
    mixedUseSame: "Utiliser les mêmes conditions pour tous",
    mixedEditOne: "Modifier ce compte uniquement",
    removeFromAllConfirm_one: "Les conditions de revenus seront supprimées de {{count}} position {{symbol}}. Les actions et ETF reviennent aux données automatiques.",
    removeFromAllConfirm_other: "Les conditions de revenus seront supprimées des {{count}} positions {{symbol}}. Les actions et ETF reviennent aux données automatiques.",
    faceValuePerUnitGroupHint_one: "{{units}} unité sur {{count}} position · {{total}} au total",
    faceValuePerUnitGroupHint_other: "{{units}} unités sur {{count}} positions · {{total}} au total",
    select: "Sélectionner…",
    none: "Aucun",
    otherIndex: "Autre",
    namePlaceholder: "ex. Pension de l'État",
    netRentHint: "Saisissez le loyer que vous gardez réellement après charges et vacance.",
    previewAnnual: "≈ {{amount}} / an",
    previewNext: "prochain paiement {{date}}",
    previewEnds: "fin {{year}}",
    removeTerms: "Supprimer les conditions",
    deleteStream: "Supprimer le flux",
    saved: "Conditions de revenus enregistrées",
    deleted: "Conditions de revenus supprimées",
    saveFailed: "Impossible d'enregistrer les conditions de revenus.",
    issuer: {
      GOVERNMENT: "État",
      CORPORATE: "Entreprise",
    },
    fields: {
      faceValueTotal: "Valeur nominale totale",
      incomeType: "Type de revenu",
      issuerType: "Émetteur",
      faceValuePerUnit: "Valeur nominale par unité",
      couponRate: "Taux du coupon",
      realCoupon: "Coupon réel",
      referenceIndex: "Indice de référence",
      assumedIndexRate: "Taux supposé de l'indice",
      spread: "Écart",
      frequency: "Fréquence",
      maturityDate: "Date d'échéance",
      anchorPaymentDate: "Une date de paiement",
      monthlyRent: "Loyer mensuel net",
      annualIndexationPct: "Indexation annuelle",
      leaseStart: "Début du bail",
      leaseEndDate: "Fin du bail",
      apyPct: "Taux annuel",
      yieldPct: "Rendement",
      orYieldPct: "…ou rendement",
      dividendPerUnit: "Dividende annuel par action",
      name: "Nom",
      category: "Catégorie",
      amountPerPayment: "Montant par paiement",
      currency: "Devise",
      startDate: "Date de début",
      endDate: "Date de fin",
    },
    errors: {
      required: "Obligatoire",
      invalid: "Valeur invalide",
      number: "Saisissez un nombre",
      negative: "Ne peut pas être négatif",
      date: "Saisissez une date valide",
      endBeforeStart: "Doit être après la date de début",
      currency: "Utilisez un code à 3 lettres (ex. EUR)",
    },
  },
  maintenance: {
    fullRebuildSecuritiesStep: "Il actualise aussi les données des titres de vos actions et ETF dont les données manquent ou sont anciennes.",
    securityData: {
      title: "Actualiser les données de mes titres",
      description: "Récupère à nouveau profil, dividendes et cours de toutes vos actions et ETF (résultats pour les actions uniquement). À utiliser si le calendrier des dividendes ou l'analyse des actions semble erroné.",
      button: "Actualiser les titres",
    },
    globalFundamentals: {
      title: "Actualiser les fondamentaux de tous les symboles (global)",
      description: "Actualise la table SecurityMaster partagée pour tous les symboles détenus par tous les locataires, pas seulement les vôtres. Plus lourd que l'actualisation de vos titres ; à utiliser après un incident du fournisseur de données.",
    },
  },

  // Manage Assets page (#81)
  manageAssets: {
    title: "Gérer les actifs",
    subtitle: "Tous vos actifs et passifs au même endroit : prix, conditions de revenus, conditions de dette et classes d'actifs.",
    loadFailed: "Impossible de charger les actifs. Veuillez réessayer.",
    assetClassHint: "S'applique à toutes les positions de {{symbol}}. Choisissez Automatique pour supprimer la modification.",
    searchPlaceholder: "Rechercher par symbole ou nom",
    empty: "Aucun actif ne correspond à ces filtres.",
    count: "{{count}} actifs",
    count_one: "{{count}} actif",
    count_other: "{{count}} actifs",
    loadMore: "Charger plus",
    loadingMore: "Chargement…",
    columns: {
      assetClass: "Classe d'actif",
    },
    filters: {
      type: "Type",
      allTypes: "Tous les types",
      account: "Compte",
      allAccounts: "Tous les comptes",
      assetClass: "Classe d'actif",
      allAssetClasses: "Toutes les classes",
      includeClosed: "Afficher les positions clôturées",
      clear: "Effacer les filtres",
    },
    status: {
      debtTermsMissing: "Conditions de dette manquantes",
      label: "Filtrer par statut",
      stale: "Prix obsolète",
      incomeMissing: "Conditions de revenus manquantes",
      dividendOverride: "Dividende modifié",
      lotMismatch: "Incohérence de lots",
      assetClassOverridden: "Classe d'actif modifiée",
    },
    chips: {
      noPrice: "Pas encore de prix",
    },
    actions: {
      addIncomeTerms: "Ajouter les conditions de revenus",
      addDebtTerms: "Ajouter les conditions de dette",
      menu: "Actions pour {{symbol}}",
      price: "Mettre à jour le prix",
      history: "Historique des prix",
      assetClass: "Classe d'actif",
      copyTrading: "Passer en Copy Trading",
    },
    attention: {
      title: "{{count}} éléments requièrent votre attention",
      title_one: "{{count}} élément requiert votre attention",
      title_other: "{{count}} éléments requièrent votre attention",
      allClear: "Tout est à jour",
      allClearHint: "Les prix sont à jour et chaque prêt et position générant des revenus a ses conditions.",
      stale: "Prix à mettre à jour",
      debtTermsMissing: "Prêts sans conditions",
      incomeMissing: "Conditions de revenus manquantes",
      lotMismatch: "Incohérences de lots à vérifier",
    },
    sort: {
      label: "Trier",
      attention: "À traiter en premier",
      name: "A–Z",
    },
    detached: {
      title: "{{count}} ensembles de conditions de revenus sont détachés",
      title_one: "{{count}} ensemble de conditions de revenus est détaché",
      title_other: "{{count}} ensembles de conditions de revenus sont détachés",
      description: "Une reconstruction du portefeuille n'a pas pu les associer à une position. Rattachez-les ou supprimez-les.",
      review: "Examiner",
      hide: "Masquer",
    },
  },

  // Processing status (#100): header chip, page banners, Settings → Processing
  activity: {
    types: {
      PORTFOLIO_UPDATE: "Mise à jour du portefeuille",
      ANALYTICS_UPDATE: "Mise à jour des analyses",
      BANK_SYNC: "Synchronisation bancaire",
      IMPORT: "Import des transactions",
      SECURITY_DATA: "Actualisation des données de marché",
      SUBSCRIPTION_SCAN: "Analyse des abonnements",
      INSIGHTS: "Génération des analyses IA",
    },
    stages: {
      scheduling: "Planification",
      recalculating_lots: "Recalcul des lots",
      updating_cash: "Mise à jour des liquidités",
      valuing_assets: "Valorisation des actifs",
      updating_debts: "Mise à jour des dettes",
      updating_analytics: "Mise à jour des analyses",
      fetching_bank: "Récupération des transactions bancaires",
      syncing_copies: "Synchronisation des copies eToro",
      classifying: "Classification des transactions",
      processing_file: "Traitement du fichier",
      committing: "Enregistrement des transactions",
      refreshing_market_data: "Actualisation des données de marché",
      scanning: "Analyse",
      generating_insights: "Génération des analyses IA",
    },
    triggers: {
      user_change: "Votre modification",
      bank_sync: "Synchronisation bancaire",
      import: "Import",
      nightly: "Nocturne",
      manual_rebuild: "Reconstruction",
      agent: "Agent IA",
      auto_refresh: "Actualisation automatique",
    },
    states: {
      queued: "En attente",
      running: "Mise à jour",
      stalled: "Plus long que d'habitude",
      completed: "Terminé",
      failed: "Échec",
    },
    chip: {
      queued: "En attente",
      running: "Mise à jour",
      stalled: "Plus long que d'habitude",
      failed: "Échec de la mise à jour",
      ariaLabel: "État des traitements en arrière-plan",
      title: "Traitements en arrière-plan",
      empty: "Tout est à jour",
      lastUpdated: "Dernière mise à jour {{time}}",
      jobs: "{{count}} tâches",
      workerOffline: "Le processus en arrière-plan est hors ligne. Les tâches en attente démarreront à son retour.",
      failedHint: "Erreur {{code}}. Les administrateurs voient le détail dans Paramètres → Traitements.",
      pending: "Démarrage…",
    },
    banner: {
      queued: "Les chiffres de cette page vont être recalculés ({{label}}). Ils se mettront à jour automatiquement.",
      running: "Les chiffres de cette page sont en cours de recalcul ({{label}}). Ils se mettront à jour automatiquement.",
      runningProgress: "Les chiffres de cette page sont en cours de recalcul ({{label}}, {{progress}} %). Ils se mettront à jour automatiquement.",
      stalled: "Le recalcul prend plus de temps que d'habitude ({{label}}). Les chiffres peuvent ne pas être à jour.",
      failed: "La dernière mise à jour des données de cette page a échoué ({{label}}). Les chiffres peuvent ne pas être à jour.",
      updated: "Mis à jour {{time}}",
    },
    time: {
      justNow: "à l'instant",
      underSecond: "< 1 s",
      minutesAgo: "il y a {{count}} min",
      hoursAgo: "il y a {{count}} h",
      daysAgo: "il y a {{count}} j",
      seconds: "{{count}} s",
      minutes: "{{count}} min",
      hours: "{{count}} h",
    },
    processing: {
      title: "Traitements",
      description: "Le travail en arrière-plan sur vos données : ce qui tourne maintenant, les dernières 24 heures et les reconstructions.",
      liveTitle: "En cours",
      liveEmpty: "Rien n'est en cours. Vos données sont à jour.",
      recentTitle: "Dernières 24 heures",
      recentEmpty: "Aucun traitement en arrière-plan ces dernières 24 heures.",
      rebuildsTitle: "Reconstructions récentes",
      unavailable: "L'état des traitements est indisponible pour le moment.",
      workerOffline: "Le processus en arrière-plan est hors ligne. Les tâches en attente démarreront à son retour.",
      elapsed: "en cours depuis {{time}}",
      queuedFor: "en attente depuis {{time}}",
      took: "a duré {{time}}",
      finished: "terminé {{time}}",
      errorCode: "Erreur {{code}}",
      steps_one: "{{count}} étape",
      steps_other: "{{count}} étapes",
    },
    notification: {
      failed_one: "{{count}} mise à jour en arrière-plan a échoué",
      failed_other: "{{count}} mises à jour en arrière-plan ont échoué",
    },
    maintenance: {
      seeProgress: "Voir la progression",
      seeProgressHint: "La progression en direct et l'historique des reconstructions sont dans Traitements.",
    },
  },

  // Enable Banking (#132)
  // eToro copy trading (#143)
  etoro: {
    section: {
      title: "Copy trading eToro",
      description: "Suivez la valeur et la composition de vos copies eToro. Bliss les lit avec une clé de lecture de votre propre compte eToro. Il ne passe jamais d'ordre et ne crée jamais de transactions.",
      connect: "Connecter eToro",
      empty: "Aucun compte eToro connecté pour l'instant.",
      guide: "Créer une clé de lecture",
      loadFailed: "Impossible de charger vos connexions eToro.",
    },
    status: {
      ACTIVE: "Connecté",
      NEEDS_RECONNECT: "Nouvelle clé nécessaire",
    },
    connection: {
      account: "Compte Bliss",
      noAccount: "Aucun compte",
      key: "Clé",
      lastSync: "Dernière synchro",
      never: "Jamais",
      lastSyncFailed: "La dernière synchro a échoué ({{code}})",
      syncNow: "Synchroniser",
      syncStarted: "Synchronisation lancée. Les valeurs seront mises à jour dans quelques minutes.",
      cooldown: "Synchronisé récemment. Réessayez dans {{minutes}} min.",
      replaceKey: "Remplacer la clé",
      remove: "Supprimer",
      removeTitle: "Supprimer cette connexion eToro ?",
      removeDescription: "Bliss arrête de mettre à jour vos copies. Vos positions Copy Trading et leur historique sont conservés.",
      removeConfirm: "Supprimer",
      removed: "Connexion eToro supprimée",
      copies: "Copies",
      noCopies: "Aucune copie sur ce compte.",
    },
    copy: {
      closed: "Fermée sur eToro",
      linkedTo: "Liée à {{symbol}}",
      notLinked: "Non liée",
      notLinkedHint: "Enregistrez cette copie comme position Copy Trading avec le ticker {{username}} dans ce compte, ou passez un fonds existant en Copy Trading dans Gérer les actifs.",
      startedAt: "Depuis le {{date}}",
    },
    dialog: {
      title: "Connecter eToro",
      replaceTitle: "Remplacer la clé eToro",
      description: "Créez une clé de lecture dans eToro (Paramètres → Trading → Gestion des clés API) et collez les deux valeurs. Bliss refuse les clés qui peuvent passer des ordres.",
      apiKey: "Clé API",
      userKey: "Clé utilisateur",
      userKeyHint: "Stockée chiffrée et jamais réaffichée.",
      account: "Compte Bliss",
      accountHint: "Le compte où vous enregistrez vos copies eToro.",
      accountPlaceholder: "Choisir un compte",
      submit: "Connecter",
      replaceSubmit: "Enregistrer la clé",
      checking: "Vérification auprès d'eToro…",
      successTitle: "Connecté en tant que {{username}}",
      successCopies_one: "{{count}} copie trouvée",
      successCopies_other: "{{count}} copies trouvées",
      noCopies: "Aucune copie sur ce compte pour l'instant.",
      done: "Terminé",
      cancel: "Annuler",
    },
    errors: {
      ETORO_WRITE_SCOPE: "Cette clé peut passer des ordres. Créez une clé de lecture dans eToro et utilisez-la.",
      ETORO_KEY_INVALID: "eToro n'a pas accepté cette clé. Vérifiez les deux valeurs et sa date d'expiration.",
      ETORO_UNAVAILABLE: "eToro est injoignable. Réessayez plus tard.",
      ETORO_RATE_LIMITED: "eToro limite les requêtes. Réessayez dans une minute.",
      ETORO_ALREADY_CONNECTED: "Ce compte eToro est déjà connecté.",
      ETORO_DIFFERENT_LOGIN: "Cette clé appartient à un autre compte eToro.",
      KEYS_REQUIRED: "Saisissez les deux clés.",
      ACCOUNT_REQUIRED: "Choisissez un compte Bliss.",
      generic: "Une erreur s'est produite. Réessayez.",
    },
    badge: {
      linked: "Liée à eToro",
      needsReconnect: "La clé eToro doit être remplacée",
      closed: "Copie fermée sur eToro",
      notLinked: "Non liée à eToro",
      lastValue: "Valeur eToro du {{date}}",
    },
    convert: {
      title: "Passer en Copy Trading",
      description: "Déplacez {{symbol}} dans la catégorie Copy Trading. Ses transactions, conditions de revenus et son historique restent inchangés. Une fois votre compte eToro connecté, Bliss suit la valeur et la composition de la copie.",
      username: "Nom d'utilisateur eToro de l'investisseur copié",
      usernamePlaceholder: "@investisseur",
      pickCopy: "Choisissez la copie",
      otherInvestor: "Un autre investisseur",
      matched: "correspond au nom",
      otherAccount: "Votre connexion eToro utilise le compte {{account}}. Cet actif est dans un autre compte et ne sera pas lié après le changement : déplacez d'abord ses transactions vers {{account}}.",
      submit: "Passer",
      success: "{{symbol}} est maintenant une position Copy Trading",
      errors: {
        INVALID_USERNAME: "Saisissez un nom d'utilisateur eToro valide.",
        COPY_HOLDING_EXISTS: "Ce compte a déjà une position pour cet investisseur.",
        COPY_TRADING_CATEGORY_MISSING: "La catégorie Copy Trading est absente. Demandez à votre administrateur Bliss de l'ajouter.",
        generic: "Impossible de modifier cette position. Réessayez.",
      },
    },
  },
  enableBanking: {
    connect: {
      button: "Connecter une banque UE (Enable Banking)",
      title: "Connecter une banque européenne",
      description: "Choisissez votre banque. Vous serez redirigé vers son site pour autoriser un accès en lecture seule via Enable Banking.",
      search: "Rechercher une banque",
      loading: "Chargement des banques...",
      loadFailed: "Impossible de charger la liste des banques. Réessayez plus tard.",
      noBanks: "Aucune banque trouvée pour les pays de votre espace.",
      startDate: "Les transactions seront importées à partir du",
      consentDays_one: "L'accès dure jusqu'à {{count}} jour, puis il faudra vous reconnecter.",
      consentDays_other: "L'accès dure jusqu'à {{count}} jours, puis il faudra vous reconnecter.",
      continue: "Continuer vers la banque",
      redirecting: "Redirection...",
      errorCountryNotEnabled: "Le pays de cette banque n'est pas activé pour votre espace.",
      errorUnknownBank: "Cette banque n'est plus disponible. Choisissez-en une autre.",
      errorGeneric: "Impossible de démarrer la connexion bancaire. Réessayez plus tard.",
    },
    callback: {
      reconnectedTitle: "Reconnectée — synchronisation en cours",
      reconnectedDesc: "L'accès à votre banque a été renouvelé et une synchronisation a démarré.",
      errorTitle: "Échec de la connexion bancaire",
      invalid_state: "Le lien de connexion a expiré ou a déjà été utilisé. Recommencez depuis Comptes.",
      denied: "L'accès n'a pas été accordé par votre banque. Rien n'a été connecté.",
      exchange_failed: "Votre banque n'a pas confirmé la connexion. Réessayez dans quelques minutes.",
      not_enabled: "Enable Banking n'est pas configuré pour votre espace. Un administrateur peut l'ajouter dans Paramètres → Synchro bancaire.",
      unknown: "Une erreur s'est produite lors de la connexion à votre banque.",
    },
    mapping: {
      title: "Associez vos comptes bancaires",
      description: "Choisissez le compte Bliss alimenté par chaque compte {{bank}}.",
      loading: "Chargement des comptes...",
      loadFailed: "Impossible de charger cette connexion. Réessayez plus tard.",
      unnamed: "Compte bancaire",
      balance: "Solde {{amount}}",
      syncInto: "Synchroniser vers",
      existingAccounts: "Comptes existants",
      createNew: "Créer un nouveau compte",
      dontSync: "Ne pas synchroniser",
      linkedPlaid: "synchronisé via Plaid",
      linkedEnableBanking: "synchronisé via une autre connexion",
      switchHint: "Ce compte est synchronisé par une autre connexion. L'associer ici déplace sa synchronisation vers cette banque ; son historique est conservé.",
      conflict: "Déjà synchronisé via la connexion d'une autre personne — autorisez un compte joint avec un seul titulaire.",
      newName: "Nom du compte",
      newBank: "Banque",
      newCountry: "Pays",
      newCurrency: "Devise",
      createBankOption: "Ajouter « {{name}} »",
      noAccounts: "Votre banque n'a renvoyé aucun compte.",
      submit: "Associer les comptes",
      submitting: "Association...",
      successTitle: "Comptes associés — synchronisation en cours",
      successDesc_one: "{{count}} compte sera synchronisé. La première synchronisation a démarré.",
      successDesc_other: "{{count}} comptes seront synchronisés. La première synchronisation a démarré.",
      successNoneDesc: "Aucun compte n'a été associé. Vous pourrez les associer plus tard depuis cette connexion.",
      errorAlreadyConnected: "L'un de ces comptes bancaires est déjà synchronisé via une autre connexion.",
      errorDuplicate: "Deux comptes bancaires ne peuvent pas alimenter le même compte Bliss.",
      errorCreateIncomplete: "Renseignez le nom, la banque, le pays et la devise de chaque nouveau compte.",
      errorGeneric: "Impossible d'associer les comptes. Réessayez.",
      switchTitle: "Changer de fournisseur de synchronisation ?",
      switchDesc: "Ces comptes ne seront plus synchronisés par leur fournisseur actuel mais via Enable Banking. Leur historique est conservé.",
      switchFrom: "Actuellement synchronisé via {{provider}} ({{bank}})",
      switchConfirm: "Changer et associer",
      providerPlaid: "Plaid",
      providerEnableBanking: "Enable Banking",
    },
    card: {
      title: "Connexion Enable Banking",
      statusActive: "Active",
      statusExpiring: "Expire bientôt",
      statusExpired: "Expirée",
      statusError: "Erreur",
      statusDisconnected: "Déconnectée",
      statusNeedsMapping: "À associer",
      expiringDesc: "L'accès bancaire se termine bientôt. Reconnectez-vous pour continuer la synchronisation.",
      expiredDesc: "L'accès bancaire est terminé. Reconnectez-vous pour reprendre la synchronisation.",
      errorDesc: "La dernière synchronisation a échoué. Réessayez plus tard ou reconnectez-vous.",
      needsMappingDesc: "Choisissez les comptes Bliss alimentés par cette banque avant de pouvoir synchroniser.",
      bank: "Banque",
      accessExpires: "Fin de l'accès",
      expiresIn_one: "{{date}} ({{count}} jour restant)",
      expiresIn_other: "{{date}} ({{count}} jours restants)",
      lastSync: "Dernière synchronisation",
      balanceAsOf: "au {{date}}",
      syncNow: "Synchroniser",
      syncStarted: "Synchronisation démarrée",
      syncStartedDesc: "Les nouvelles transactions apparaîtront sous peu.",
      syncFailed: "Impossible de lancer la synchronisation",
      syncNotActive: "Reconnectez cette banque avant de synchroniser.",
      syncNoAccounts: "Associez au moins un compte avant de synchroniser.",
      budgetTitle: "Limite quotidienne d'actualisations atteinte",
      budgetDesc: "Votre banque n'autorise que quelques actualisations par jour. Vous pourrez resynchroniser après {{time}}.",
      budgetDescNoTime: "Votre banque n'autorise que quelques actualisations par jour. Réessayez demain.",
      reconnect: "Reconnecter",
      reconnectOnlyAuthoriser: "Seule la personne qui a autorisé cette connexion peut la reconnecter.",
      reconnectFailed: "Impossible de démarrer la reconnexion. Réessayez plus tard.",
      mapAccounts: "Associer les comptes",
      manageAccounts: "Gérer les comptes",
      disconnect: "Déconnecter",
      disconnecting: "Déconnexion...",
      disconnectOnlyAdmin: "Seul un administrateur ou la personne qui a autorisé cette connexion peut la déconnecter.",
      disconnectTitle: "Déconnecter {{bank}} ?",
      disconnectDesc: "La synchronisation s'arrête et l'accès bancaire est révoqué. Vos comptes et leur historique de transactions sont conservés.",
      disconnected: "Banque déconnectée",
      disconnectedDesc: "La synchronisation est arrêtée. Vos comptes et leur historique sont conservés.",
      disconnectFailed: "Échec de la déconnexion",
      statusPaused: "En pause",
      pausedDesc: "En pause : identifiants manquants.",
      pausedAdminLink: "Configurer la synchro bancaire",
      pausedAskAdmin: "Demandez à un administrateur d'ajouter les identifiants Enable Banking.",
    },
    pending: {
      message: "{{bank}} est connectée, mais aucun compte n'est encore associé. Choisissez les comptes à synchroniser.",
    },
    detail: {
      badge: "Enable Banking",
      deleteBlockedHint: "Déconnectez d'abord cette connexion bancaire (bouton « Déconnecter » ci-dessus) avant de supprimer le compte.",
    },
    credentials: {
      title: "Enable Banking (banques de l’UE)",
      intro: "Synchronisez automatiquement vos comptes de banques européennes avec votre propre application Enable Banking. Une application gratuite peut relier jusqu’à 5 comptes.",
      guideLink: "Lire le guide de configuration",
      callbackLabel: "URL de retour",
      callbackHint: "Enregistrez cette URL comme URL de redirection de votre application Enable Banking.",
      copy: "Copier",
      copied: "Copié",
      appIdLabel: "Identifiant de l'application",
      appIdInvalid: "L'identifiant de l'application est un UUID, par exemple 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      keyLabel: "Clé privée",
      save: "Enregistrer et vérifier",
      saving: "Vérification...",
      cancel: "Annuler",
      statusVERIFIED: "Vérifiés",
      statusUNVERIFIED: "Non vérifiés",
      statusINVALID: "Invalides",
      unverifiedDesc: "Enable Banking n'a pas pu être joint pour vérifier ces identifiants. Ils sont enregistrés ; utilisez Revérifier pour réessayer.",
      invalidDesc: "Enable Banking a refusé ces identifiants. Les synchronisations planifiées sont suspendues jusqu’à ce que vous les revérifiiez ou les remplaciez.",
      callbackMissing: "L'URL de retour n'est pas encore enregistrée sur cette application. Les connexions bancaires échoueront tant qu'elle ne l'est pas.",
      appId: "Identifiant de l'application",
      fingerprint: "Empreinte de la clé",
      keyBits: "RSA {{bits}} bits",
      lastValidated: "Dernière vérification",
      never: "Jamais",
      linkedAccounts: "Comptes reliés",
      linkedAccountsValue: "{{used}} sur {{limit}}",
      activeConnections: "Connexions actives",
      replace: "Remplacer les identifiants",
      reverify: "Revérifier",
      remove: "Supprimer",
      replaceHint: "Pour changer seulement la clé, gardez l'identifiant de l'application et importez le nouveau fichier.",
      savedTitle: "Enable Banking est configuré",
      savedDesc: "Votre espace peut maintenant connecter des banques européennes depuis Comptes.",
      savedUnverifiedDesc: "Enregistrés, mais Enable Banking n'a pas pu être joint pour les vérifier. Utilisez Revérifier plus tard.",
      verifiedTitle: "Identifiants vérifiés",
      stillInvalidTitle: "Enable Banking refuse toujours ces identifiants",
      stillUnverifiedTitle: "Enable Banking n'a pas pu être joint",
      removedTitle: "Identifiants supprimés",
      removedDesc: "Les connexions sont en pause jusqu’à ce que des identifiants soient ajoutés.",
      errorINVALID_CREDENTIALS: "Enable Banking a refusé ces identifiants. Vérifiez que la clé privée appartient à cette application.",
      errorSANDBOX_APP: "Il s’agit d’une application sandbox. Créez une application de production en mode restreint.",
      errorINVALID_APP_ID: "L'identifiant de l'application est un UUID, par exemple 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      errorGeneric: "Impossible d'enregistrer les identifiants. Réessayez.",
      loadFailed: "Impossible de charger les paramètres Enable Banking.",
      confirmAppChangeTitle: "Changer d'application Enable Banking ?",
      confirmAppChangeDesc_one: "{{count}} connexion cessera de se synchroniser jusqu'à sa reconnexion. Ses comptes et son historique sont conservés.",
      confirmAppChangeDesc_other: "{{count}} connexions cesseront de se synchroniser jusqu'à leur reconnexion. Leurs comptes et leur historique sont conservés.",
      confirmRemoveTitle: "Supprimer les identifiants Enable Banking ?",
      confirmRemoveDesc_one: "{{count}} connexion sera en pause jusqu'à l'ajout de nouveaux identifiants. Les comptes, les liaisons et les transactions sont conservés.",
      confirmRemoveDesc_other: "{{count}} connexions seront en pause jusqu'à l'ajout de nouveaux identifiants. Les comptes, les liaisons et les transactions sont conservés.",
      confirmContinue: "Continuer",
      pausedBanner_one: "{{count}} connexion est en pause jusqu’à ce que vous ajoutiez vos identifiants Enable Banking.",
      pausedBanner_other: "{{count}} connexions sont en pause jusqu’à ce que vous ajoutiez vos identifiants Enable Banking.",
      historyTitle: "Historique des modifications",
      historyEmpty: "Aucune modification pour l’instant.",
      historySET: "Configurés",
      historyREPLACED: "Remplacés",
      historyKEY_ROTATED: "Clé changée",
      historyREMOVED: "Supprimés",
      historyBy: "par {{name}}",
      historyUnknownUser: "un ancien membre",
      notification: "Les identifiants Enable Banking demandent votre attention",
      setupLink: "Configurer la synchro des banques de l’UE",
    },
    keyInput: {
      drop: "Déposez ici le fichier .pem fourni par Enable Banking",
      choose: "Choisir un fichier",
      pasteInstead: "Coller plutôt",
      uploadInstead: "Importer un fichier plutôt",
      pasteLabel: "Clé privée (PEM)",
      valid: "Clé privée RSA valide · {{bits}} bits",
      clear: "Retirer",
      readFailed: "Impossible de lire ce fichier.",
      errorKEY_NOT_PEM: "Ce n'est pas une clé privée PEM.",
      errorKEY_PUBLIC: "C’est une clé publique. Utilisez la clé privée (.pem) fournie par Enable Banking.",
      errorKEY_CERTIFICATE: "C'est un certificat, pas une clé privée.",
      errorKEY_NOT_RSA: "Seules les clés privées RSA sont acceptées.",
      errorKEY_ENCRYPTED: "Les clés protégées par mot de passe ne sont pas acceptées. Utilisez le .pem non chiffré d’Enable Banking.",
      errorKEY_TRUNCATED: "La clé semble incomplète : la ligne END manque ou le texte est coupé.",
      errorKEY_TOO_LARGE: "Plus de 16 Ko, trop volumineux pour une clé privée.",
      errorKEY_TOO_SMALL: "Les clés RSA doivent faire au moins 2048 bits.",
    },
    settings: {
      historyDaysHint: "S'applique aussi aux connexions Enable Banking.",
    },
  },
  // Installable PWA (#155)
  pwa: {
    install: {
      button: "Installer l'app",
      settingsTitle: "Application Bliss",
      settingsDescription: "Installez Bliss pour l'ouvrir dans sa propre fenêtre, depuis l'écran d'accueil, le Dock ou la barre des tâches.",
      bannerTitle: "Installez l'application Bliss",
      bannerDescription: "Ouvrez Bliss dans sa propre fenêtre, depuis l'écran d'accueil, le Dock ou la barre des tâches.",
      dismiss: "Ignorer",
      iosTitle: "Ajoutez Bliss à votre écran d'accueil",
      iosStep1: "Touchez le bouton Partager dans la barre du navigateur.",
      iosStep2: "Faites défiler et touchez « Sur l'écran d'accueil ».",
      iosStep3: "Touchez « Ajouter ». Bliss apparaît sur votre écran d'accueil.",
      iosSignInNote: "L'app ne partage pas la session de votre navigateur : vous vous connectez une fois dans l'app.",
      done: "Compris",
    },
    update: {
      reload: "Recharger",
    },
    banks: {
      desktopOnly: "Connectez et reconnectez vos banques depuis un navigateur d'ordinateur. Les transactions synchronisées restent consultables ici.",
    },
    offline: {
      title: "Vous êtes hors ligne",
      description: "Bliss a besoin d'une connexion pour afficher vos données. Vos chiffres se rechargent dès que vous êtes de nouveau en ligne.",
      retry: "Réessayer",
    },
  },
  // Onboarding wizard (#154): every step, namespaced
  onboarding: {
    welcome: {
      title: "Bienvenue sur",
      subtitle: "Personnalisons votre expérience",
      countries: "Vos pays",
      currencies: "Vos devises",
    },
    connect: {
      title: "Connectez vos comptes",
      subtitle: "Liez une banque pour la synchronisation automatique, importez un tableur ou ajoutez des comptes manuellement",
      bankTitle: "Connectez votre banque",
      bankDescription: "Choisissez le fournisseur qui couvre votre banque. Vous pourrez ajouter l'autre plus tard.",
      learnMore: "En savoir plus",
      plaid: {
        title: "Plaid — banques des États-Unis, du Canada et du Royaume-Uni",
        description: "Liez vos comptes bancaires en toute sécurité via Plaid pour synchroniser automatiquement vos transactions.",
        button: "Connecter un compte bancaire",
        notConfigured: "Plaid n'est pas configuré sur ce serveur.",
        notConfiguredHint: "L'administrateur du serveur ajoute les clés Plaid ; le guide explique comment.",
        error: "Impossible de joindre Plaid, réessayez plus tard.",
      },
      enableBanking: {
        title: "Enable Banking — banques de l'UE",
        description: "Liez des banques de l'UE via le consentement DSP2, avec votre propre application Enable Banking.",
        connect: "Connecter une banque de l'UE",
        setup: "Configurer la synchronisation des banques de l'UE",
        adminOnly: "Un administrateur de l'espace de travail peut configurer la synchronisation des banques de l'UE dans les Paramètres.",
      },
      setup: {
        title: "Configurer la synchronisation des banques de l'UE",
        description: "Bliss se connecte aux banques de l'UE via votre propre application Enable Banking. Ajoutez son identifiant et sa clé privée : Bliss les vérifie avant de les enregistrer, puis vous choisissez votre banque.",
        needTitle: "Ce qu'il vous faut",
        needAccount: "Un compte Enable Banking",
        needApp: "Une application de production en mode restreint",
        needCallback: "L'URL de rappel ci-dessous enregistrée sur cette application",
        limit: "Le mode restreint permet de lier jusqu'à 5 de vos propres comptes bancaires.",
        guide: "Guide pas à pas",
      },
      importTitle: "Importer un tableur",
      importDescription: "Téléversez un fichier CSV ou Excel contenant vos transactions.",
    },
    accounts: {
      title: "Ajoutez vos banques et comptes",
      subtitle: "Choisissez les banques que vous utilisez et ajoutez un compte pour chacune. Vous pourrez renseigner les numéros de compte plus tard.",
      selectBanks: "Sélectionnez vos banques",
      addDifferentBank: "Ajouter une autre banque",
      bankName: "Nom de la banque",
      account: "Compte",
      addAccount: "Ajouter un compte",
      removeAccount: "Supprimer le compte",
      removeBank: "Supprimer la banque",
      bankCap: "Vous pouvez ajouter jusqu'à {{count}} banques ici ; vous pourrez en ajouter d'autres plus tard.",
      pickCountry: "Choisissez le pays de chaque compte ; par défaut : {{country}}.",
      createdIn: "Les comptes seront créés en {{country}}.",
      skip: "Passer pour l'instant",
      create_one: "Créer {{count}} compte",
      create_other: "Créer {{count}} comptes",
    },
    errors: {
      noTenant: "Espace de travail introuvable",
      tenantMissing: "Nom ou offre de l'espace de travail manquant. Contactez le support.",
      savePreferences: "Impossible d'enregistrer vos préférences. Veuillez réessayer.",
      noUser: "Impossible d'identifier votre utilisateur. Veuillez réessayer.",
      setupAccounts: "Impossible de configurer vos comptes. Veuillez réessayer.",
    },
  },
};

export default fr;
